<template class="font-Prompt">
  <div id="question_page" class="question-page">
    <div class="relative">
      <div v-if="shadowScreen" class="full-screen-shadow"></div>
    </div>
    <div class="head-link-container flex-center">
      <div
        v-if="showBackBTN()"
        @click="step = backBTN()"
        class="bt-back flex-mid"
      >
        <svg
          width="9"
          height="15"
          viewBox="0 0 9 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.95079 0.302444C8.35364 0.705703 8.35364 1.35951 7.95079 1.76277L2.49082 7.22826L7.95079 12.6938C8.35364 13.097 8.35364 13.7508 7.95079 14.1541C7.54794 14.5573 6.89479 14.5573 6.49194 14.1541L0.302541 7.95843C-0.100311 7.55517 -0.100311 6.90136 0.302541 6.4981L6.49194 0.302444C6.89479 -0.100815 7.54794 -0.100815 7.95079 0.302444Z"
            fill="#037968"
          />
        </svg>
      </div>
      <div class="flex-mid m-auto">
        <span
          v-if="showStepValue()"
          class="fs-16 fw-500"
          style="color: #2d7617"
        >
          {{ $t("questionNo") }}
          {{ showStepValue() }}
          {{ $t("outOf") }} 7
        </span>
      </div>
      <div
        @click="$router.push('/home')"
        v-if="step != 'question_finish'"
        class="link right"
      >
        {{ $t("skip") }}
      </div>
    </div>
    <div class="step-progress" v-if="step != 'let_start'">
      <div
        v-for="id in returnMockArray(showStepValue())"
        :key="id"
        class="step-bar fs-2"
      >
        &nbsp;
      </div>
    </div>
    <div
      v-if="step == 'let_start' || step == 'Sync_data_dialog'"
      class="center"
    >
      <div class="image-middle flex-mid mx-auto">
        <img
          src="@/assets/image/Question/girl-tapping-phone.gif"
          alt=""
          class="mx-auto"
          style="width: 70%; height: 70%; object-fit: scale-down"
        />
      </div>
      <div class="questionatitle" style="line-height: 22px">
        {{ $t("questionatitle") }}
      </div>
      <div
        id="startQuestionaire"
        @click="letStart()"
        style="width: 24rem"
        class="btn-48 btn-question btn mx-auto mt-28"
      >
        {{ $t("start") }}
      </div>
    </div>
    <div v-else-if="step == 'question_sex'" class="center sex-container">
      <div class="form-container">
        <div
          :class="`question-title body-max-width ${
            lang == 'th' ? 'font-Prompt fs-38' : 'fs-22'
          }`"
        >
          {{ $t("sex") }}
        </div>
        <div
          id="selectSex"
          class="select-box flex-center mx-auto"
          style="margin-top: 4rem"
          @click="switchSex()"
        >
          <div :class="`button white-cyecle ${form.sex}`">&nbsp;</div>
          <div
            :class="`button mr-auto ml-10 flex-mid ${
              form.sex == 'M' ? 'focus' : ''
            }`"
          >
            <div class="center">
              <svg
                width="52"
                height="54"
                viewBox="0 0 52 54"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M25.9999 24.75C27.714 24.75 29.3896 24.2222 30.8149 23.2332C32.2401 22.2443 33.3509 20.8387 34.0069 19.1942C34.6628 17.5496 34.8345 15.74 34.5001 13.9942C34.1657 12.2484 33.3402 10.6447 32.1282 9.38604C30.9161 8.12737 29.3719 7.2702 27.6907 6.92294C26.0095 6.57567 24.267 6.7539 22.6833 7.43509C21.0997 8.11628 19.7462 9.26983 18.7938 10.7499C17.8415 12.2299 17.3333 13.97 17.3333 15.75C17.3333 18.137 18.2463 20.4261 19.8717 22.114C21.497 23.8018 23.7014 24.75 25.9999 24.75Z"
                  :fill="`${form.sex == 'M' ? '#2D7617' : '#525252'}`"
                />
                <path
                  d="M38.9999 47.25C39.5746 47.25 40.1257 47.0129 40.532 46.591C40.9383 46.169 41.1666 45.5967 41.1666 45C41.1666 40.8228 39.5687 36.8168 36.7244 33.8631C33.8801 30.9094 30.0224 29.25 25.9999 29.25C21.9775 29.25 18.1198 30.9094 15.2755 33.8631C12.4312 36.8168 10.8333 40.8228 10.8333 45C10.8333 45.5967 11.0615 46.169 11.4679 46.591C11.8742 47.0129 12.4253 47.25 12.9999 47.25H38.9999Z"
                  :fill="`${form.sex == 'M' ? '#2D7617' : '#525252'}`"
                />
              </svg>
              <br />
              <p class="fs-16 fw-400">{{ $t("male") }}</p>
            </div>
          </div>
          <div
            :class="`button ml-auto mr-10 flex-mid ${
              form.sex == 'M' ? '' : 'focus'
            }`"
          >
            <div class="center">
              <svg
                width="31"
                height="41"
                viewBox="0 0 31 41"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M28.0795 40.8451C28.6524 40.8451 29.2018 40.6092 29.6068 40.1894C30.0119 39.7696 30.2395 39.2002 30.2395 38.6066C30.2395 34.4507 28.6465 30.4651 25.811 27.5265C22.9755 24.5879 19.1297 22.937 15.1197 22.937C11.1097 22.937 7.26397 24.5879 4.42847 27.5265C1.59297 30.4651 5.97537e-08 34.4507 0 38.6066C0 39.2002 0.227567 39.7696 0.632639 40.1894C1.03771 40.6092 1.5871 40.8451 2.15996 40.8451H28.0795Z"
                  :fill="`${form.sex == 'M' ? '#525252' : '#2D7617'}`"
                />
                <path
                  d="M24.3527 16.213H23.3367V8.64692C23.3367 3.87136 19.4653 0 14.6897 0C9.91419 0 6.04283 3.87136 6.04283 8.64692V16.213H5.08086C4.48392 16.213 4 16.6969 4 17.2938C4 17.8908 4.48392 18.3747 5.08086 18.3747H24.3527C24.9496 18.3747 25.4335 17.8908 25.4335 17.2938C25.4335 16.6969 24.9496 16.213 24.3527 16.213Z"
                  :fill="`${form.sex == 'M' ? '#525252' : '#2D7617'}`"
                />
              </svg>
              <br />
              <p class="fs-16 fw-400">{{ $t("female") }}</p>
            </div>
          </div>
        </div>
        <div
          v-if="!form.ssid || form.ssid == 'xx'"
          :class="`question-title  body-max-width ${
            lang == 'th' ? 'font-Prompt fs-38' : 'fs-22'
          }`"
          style="margin-top: 6rem"
        >
          {{ $t("dateofbirth") }}
        </div>
        <div
          v-if="!form.ssid || form.ssid == 'xx'"
          class="flex-mid"
          style="margin-top: 6rem"
        >
          <!-- <el-select
            v-model="form.dayOfBirth"
            @change="checkDayOfBirthValidate"
            :class="{ validate: formValidate.dayOfBirth }"
            class="ml-auto date-input"
            placeholder=" "
          >
            <el-option
              v-for="item in options.day"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select> -->
          <div class="relative">
            <div class="absolute-mid focus-bg-date"></div>
            <div class="absolute-mid top-bottom-bg-date"></div>
            <swiper
              id="selectBirthDate"
              v-if="form.monthOfBirth == 2 && isLeapYear == true"
              :direction="'vertical'"
              class="date-selected-date"
              :initialSlide="form.dayOfBirth - 1"
              :slides-per-view="3"
              :centeredSlides="true"
              :modules="modules"
              :mousewheel="true"
              :grabCursor="true"
              @slideChange="onSlideDayChange"
            >
              <swiper-slide v-for="index in 29" :id="index" :key="index">
                <div
                  class="flex-mid fc-DBDBDB fs-18 fw-500"
                  style="height: 3.6rem; color: #000"
                >
                  {{ index }}
                </div>
              </swiper-slide>
            </swiper>

            <swiper
              id="selectBirthDate"
              v-else-if="form.monthOfBirth == 2 && isLeapYear == false"
              :direction="'vertical'"
              class="date-selected-date"
              :initialSlide="form.dayOfBirth - 1"
              :slides-per-view="3"
              :centeredSlides="true"
              :modules="modules"
              :mousewheel="true"
              :grabCursor="true"
              @slideChange="onSlideDayChange"
            >
              <swiper-slide v-for="index in 28" :id="index" :key="index">
                <div
                  class="flex-mid fc-DBDBDB fs-18 fw-500"
                  style="height: 3.6rem; color: #000000"
                >
                  {{ index }}
                </div>
              </swiper-slide>
            </swiper>

            <swiper
              id="selectBirthDate"
              v-else
              :direction="'vertical'"
              class="date-selected-date"
              :initialSlide="form.dayOfBirth - 1"
              :slides-per-view="3"
              :centeredSlides="true"
              :modules="modules"
              :mousewheel="true"
              :grabCursor="true"
              @slideChange="onSlideDayChange"
            >
              <swiper-slide v-for="index in 31" :id="index" :key="index">
                <div
                  class="flex-mid fs-16 fw-400"
                  style="height: 3.6rem; color: #000000"
                >
                  {{ index }}
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <!-- <el-select
            v-model="form.monthOfBirth"
            @change="checkMonthOfBirthValidate"
            :class="{ validate: formValidate.monthOfBirth }"
            class="ml-6 mr-6 date-input"
            placeholder=" "
          >
            <el-option
              v-for="item in options.month"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select> -->
          <div class="relative">
            <div class="absolute-mid focus-bg-month"></div>
            <div class="absolute-mid top-bottom-bg-month"></div>
            <swiper
              id="selectBirthMonth"
              :direction="'vertical'"
              class="date-selected-month"
              :slides-per-view="3"
              :centeredSlides="true"
              :initialSlide="form.monthOfBirth - 1"
              :modules="modules"
              :mousewheel="true"
              :grabCursor="true"
              @slideChange="onSlideMonthChange"
            >
              <swiper-slide
                v-for="(item, index) in options.month"
                :id="index"
                :key="index"
              >
                <div
                  class="flex-mid fs-16 fw-400"
                  style="height: 3.6rem; color: #000000"
                >
                  {{ $t(item) }}
                </div>
              </swiper-slide>
            </swiper>
          </div>

          <div class="relative">
            <div class="absolute-mid focus-bg-year"></div>
            <div class="absolute-mid top-bottom-bg-year"></div>
            <swiper
              id="selectBirthYear"
              :direction="'vertical'"
              class="date-selected-year"
              :slides-per-view="3"
              :centeredSlides="true"
              :initialSlide="
                getArrForYears().indexOf(parseInt(form.yearOfBirth))
              "
              :modules="modules"
              :mousewheel="true"
              :grabCursor="true"
              @slideChange="onSlideYearChange"
            >
              <swiper-slide
                v-for="item in getArrForYears()"
                :id="item"
                :key="item"
              >
                <div
                  v-if="lang == 'th'"
                  class="flex-mid fs-16 fw-400"
                  style="height: 3.6rem; color: #000000"
                >
                  {{ item + 543 }}
                </div>

                <div
                  v-else
                  class="flex-mid fs-16 fw-400"
                  style="height: 3.6rem; color: #000000"
                >
                  {{ item }}
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <!-- <el-date-picker
            v-model="dayOfBirth"
            type="date"
            placeholder="Pick a date"
          /> -->
          <!-- <el-date-picker
            v-model="form.monthOfBirth"
            type="month"
            placeholder="Pick a month"
          /> -->
          <!-- <el-date-picker
            v-model="form.yearOfBirth"
            type="year"
            placeholder="Pick a year"
          /> -->
        </div>
      </div>
      <div class="footer-nav">
        <div class="footer-btn-next">
          <div
            id="next-1"
            @click="nextDateOfBirthl"
            class="btn-48 btn-question btn mx-auto"
            :class="`${
              formValidate.dayOfBirth &&
              formValidate.monthOfBirth &&
              formValidate.yearOfBirth
                ? 'disable'
                : ''
            }`"
            style="width: 14rem"
          >
            {{ $t("next") }}
          </div>
        </div>
      </div>
    </div>

    <div
      v-else-if="step == 'question_body_details'"
      class="center body-details-container"
    >
      <div class="form-container">
        <div class="question-title body-max-width">
          {{ $t("bodyDetail") }}
        </div>

        <div class="body">
          <div class="body-details-box">
            <div class="title left">{{ $t("height") }}</div>
            <div class="body-detail-input">
              <el-input
                id="fillHeight"
                @keyup="checkHeightValidate"
                @change="checkHeightValidate"
                v-model="form.height"
                :class="{ validate: formValidate.height }"
                class="white-57"
                placeholder=" "
                type="number"
                pattern="^[\d]+$"
                inputmode="numeric"
              />
              <div class="absolute-text">{{ $t("centimeter") }}</div>
            </div>
          </div>
          <div class="body-details-box">
            <div class="title left">{{ $t("weight") }}</div>
            <div class="body-detail-input">
              <el-input
                id="fillWeight"
                @keyup="checkWeightValidate"
                @change="checkWeightValidate"
                v-model="form.weight"
                :class="{ validate: formValidate.weight }"
                class="white-57"
                placeholder=" "
                type="number"
                pattern="^[\d]+$"
                inputmode="numeric"
              />
            </div>
            <div class="absolute-text">{{ $t("kilogram") }}</div>
          </div>
          <div class="body-details-box">
            <div class="title left">{{ $t("bmi") }}</div>
            <div class="body-detail-input">
              <el-input
                v-model="bmi"
                placeholder=" "
                class="white-57"
                style="caret-color: transparent"
              />
            </div>
            <div class="absolute-text" style="margin-right: -10px">
              {{ $t("kmpermg") }}
            </div>
          </div>
          <div class="body-details-box">
            <div class="title left">{{ $t("waistline") }}</div>
            <div class="body-detail-input">
              <el-input
                id="fillWaistline"
                v-model="form.waistline"
                @keyup="checkWaistlineValidate"
                @change="checkWaistlineValidate"
                :class="{ validate: formValidate.waistline }"
                class="white-57"
                placeholder=" "
                type="number"
                pattern="^[\d]+$"
                inputmode="numeric"
              />
            </div>
            <div class="absolute-text">{{ $t("inch") }}</div>
          </div>
        </div>
      </div>
      <div class="footer-nav">
        <div class="footer-btn-next">
          <div
            id="next-3"
            @click="nextBodyDetail"
            :class="{
              disable: formValidate.height || form.height == 0,
              disable: formValidate.weight || form.weight == 0,
              disable: formValidate.waistline || form.waistline == 0,
            }"
            style="width: 14rem"
            class="btn-48 btn-question btn mx-auto"
          >
            {{ $t("next") }}
          </div>
        </div>
      </div>
    </div>
    <div
      v-else-if="step == 'question_health'"
      class="center health-details-container"
    >
      <div class="form-container">
        <div class="question-title body-max-width">
          {{ $t("healthdetail") }}
        </div>
        <div class="fs-14 fw-500 fc-2D7617 mt-6" style="color: #f57f29">
          {{ $t("optional") }}
        </div>

        <div class="body">
          <div class="health-details-box">
            <div class="left">
              {{ $t("bloodpressure") }}
            </div>
            <div class="pressure-box">
              <div class="input-box left">
                <div class="label">{{ $t("sbp") }}</div>

                <div class="pressure-input-box ml-auto">
                  <el-input
                    id="fillSBP"
                    @keyup="checkBloodPressureHeight"
                    @change="checkBloodPressureHeight"
                    v-model="form.bloodPressureHigher"
                    placeholder=" "
                    type="number"
                    pattern="^[\d]+$"
                    inputmode="numeric"
                  />
                </div>
                <div class="absolute-text">{{ $t("mmhg") }}</div>
              </div>

              <div class="input-box left">
                <div class="label">{{ $t("dbp") }}</div>

                <div class="pressure-input-box ml-auto">
                  <el-input
                    id="fillDBP"
                    @keyup="checkBloodPressureLow"
                    @change="checkBloodPressureLow"
                    v-model="form.bloodPressureLower"
                    placeholder=" "
                    type="number"
                    pattern="^[\d]+$"
                    inputmode="numeric"
                  />
                </div>
                <div class="absolute-text">{{ $t("mmhg") }}</div>
              </div>
            </div>

            <div class="left mt-10">
              {{ $t("cholesterolLDL") }}
            </div>
            <div class="cholesterol-box">
              <!-- <div class="relative mt-12"> -->
              <div class="cholesterol-input-box">
                <el-input
                  id="fillCholesterol"
                  @keyup="checkCholesterol"
                  @change="checkCholesterol"
                  v-model="form.cholesterolLDL"
                  placeholder=" "
                  :class="{ validate: formValidate.cholesterolLDL }"
                  type="number"
                  pattern="^[\d]+$"
                  inputmode="numeric"
                />
              </div>
              <div class="absolute-text">{{ $t("mgdl") }}</div>
              <!-- </div> -->
            </div>

            <div class="fs-16 fw-500 fc-545454 mt-26 left">
              {{ $t("bloodsugar") }}
            </div>
            <div class="bloodsugar-box">
              <!-- <div class="relative mt-12"> -->
              <div class="bloodsugar-input-box">
                <el-input
                  id="fillBloodSugar"
                  @keyup="checkBloodGlucose"
                  @change="checkBloodGlucose"
                  v-model="form.bloodSugar"
                  placeholder=" "
                  :class="{ validate: formValidate.bloodSugar }"
                  type="number"
                  pattern="^[\d]+$"
                  inputmode="numeric"
                />
              </div>
              <div class="absolute-text">{{ $t("mgdl") }}</div>
            </div>
            <div class="fs-16 fw-500 fc-545454 mt-26 left">
              {{ $t("HbA1c") }}
            </div>
            <div class="bloodsugar-box">
              <div class="bloodsugar-input-box">
                <el-input
                  id="fillHbA1c"
                  @keyup="checkHbA1c"
                  @change="checkHbA1c"
                  v-model="form.HbA1c"
                  :class="{ validate: formValidate.HbA1c }"
                  placeholder=" "
                  type="number"
                  pattern="^[\d]+$"
                  inputmode="decimal"
                />
              </div>
              <div class="absolute-text">{{ $t("mgdl") }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-nav">
        <div class="footer-btn-next">
          <div
            id="next-4"
            @click="nextHealthDetail"
            style="width: 14rem"
            class="btn-48 btn-question btn mx-auto"
          >
            {{ $t("next") }}
          </div>
        </div>
      </div>
    </div>
    <div
      v-else-if="step == 'question_behavior'"
      class="center behavior-container"
    >
      <div class="form-container">
        <div class="question-title body-max-width">
          {{ $t("behavior") }}
        </div>
        <div class="fs-14 fw-500 fc-2D7617 mt-6" style="color: #f57f29">
          {{ $t("morethanone") }}
        </div>

        <div class="behavior-container">
          <div class="body">
            <div
              id="buttonSnoring"
              :class="`disease-long-card  ${
                form.behavior.snoring == true ? 'select' : ''
              }`"
              @click="form.behavior.snoring = !form.behavior.snoring"
            >
              <div class="icon">
                <img
                  src="@/assets/image/NewDesign/QuestionImage/behavior/snoring.png"
                  style="width: 4.2rem; height: 4.2rem"
                />
              </div>
              <div class="label fs-13">
                {{ $t("snoring") }}
              </div>
              <div class="check-icon flex-mid">
                <svg
                  width="19"
                  height="15"
                  viewBox="0 0 19 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                    stroke="white"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
            <div
              id="buttonAlcohol"
              :class="`disease-long-card ${
                form.behavior.alcohol == true ? 'select' : ''
              }`"
              @click="form.behavior.alcohol = !form.behavior.alcohol"
            >
              <div class="icon">
                <img
                  src="@/assets/image/NewDesign/QuestionImage/behavior/alcohol.png"
                  style="width: 4.2rem; height: 4.2rem"
                />
                <!-- <svg
                  width="29"
                  height="31"
                  viewBox="0 0 31 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.7038 14.8516C11.3561 14.8516 11.0742 15.1131 11.0742 15.4355V24.3403C11.0742 24.6628 11.3561 24.9242 11.7038 24.9242C12.0514 24.9242 12.3333 24.6628 12.3333 24.3403V15.4355C12.3333 15.1131 12.0514 14.8516 11.7038 14.8516Z"
                    fill="#2D7617"
                    stroke="#2D7617"
                    stroke-width="0.8"
                  />
                  <path
                    d="M18.8405 14.8516C18.4928 14.8516 18.2109 15.1131 18.2109 15.4355V24.3403C18.2109 24.6628 18.4928 24.9242 18.8405 24.9242C19.1884 24.9242 19.47 24.6628 19.47 24.3403V15.4355C19.47 15.1131 19.1881 14.8516 18.8405 14.8516Z"
                    fill="#2D7617"
                    stroke="#2D7617"
                    stroke-width="0.8"
                  />
                  <path
                    d="M27.2383 11.7453H25.0462V9.01274C25.0857 8.97938 25.1193 8.94321 25.1559 8.90681C25.7891 8.26843 26.1461 7.41002 26.1511 6.51428C26.1561 5.61837 25.8085 4.75624 25.1823 4.11092C24.5562 3.46584 23.7011 3.0887 22.7992 3.06014L22.6741 3.05407C21.7019 3.027 20.7364 2.88273 19.7991 2.62431C19.3054 2.4612 18.826 2.25779 18.3662 2.01604C17.7887 1.713 17.1833 1.46562 16.5581 1.27784C15.2406 0.880354 13.8299 0.910033 12.5308 1.36254C11.7868 1.68508 11.1184 2.15685 10.5673 2.74843C10.2456 3.07487 9.89228 3.36884 9.51231 3.62615C9.17623 3.77626 8.80435 3.82977 8.43902 3.78037L8.34759 3.77734C7.25793 3.75806 6.20737 4.17851 5.43588 4.94253C5.35056 5.02419 5.27133 5.10889 5.19495 5.19683C5.17924 5.19098 5.16309 5.18687 5.1465 5.18449C4.88505 5.11993 4.61684 5.08744 4.34753 5.08766C3.46017 5.08917 2.60951 5.43966 1.98206 6.06242C1.35465 6.68538 1.00151 7.52977 1 8.41054C1 8.47704 1.00306 8.54679 1.00611 8.61026L1 8.61632V15.2951C1.00065 15.9651 1.2477 16.6117 1.69467 17.1136C2.14162 17.6157 2.7579 17.9385 3.42771 18.0215C4.09746 18.1046 4.77486 17.9422 5.33249 17.5646V27.1093C5.33402 28.4211 5.85975 29.6787 6.79423 30.6063C7.72874 31.5338 8.99578 32.0556 10.3172 32.0571H20.0613C21.3827 32.0556 22.6498 31.5338 23.5843 30.6063C24.5188 29.6787 25.0445 28.4211 25.046 27.1093V25.221H27.2382C28.0703 25.2208 28.8686 24.8928 29.4574 24.3089C30.046 23.7251 30.3773 22.9331 30.3784 22.1072V14.8594C30.3769 14.0334 30.0454 13.2417 29.4568 12.658C28.8682 12.0744 28.0704 11.7459 27.2383 11.7453ZM23.8267 27.1092C23.8256 28.1003 23.4286 29.0501 22.7226 29.7509C22.0166 30.4514 21.0596 30.8456 20.0614 30.8468H10.3174C9.31921 30.8457 8.36223 30.4514 7.65622 29.7509C6.95021 29.0501 6.55327 28.1003 6.55215 27.1092V11.6427C7.4456 12.0513 8.42721 12.024 9.24434 11.9999C10.2214 11.9774 11.1963 12.0987 12.1375 12.3599C12.7619 12.5491 13.4089 12.655 14.0615 12.6747C14.3245 12.6764 14.5872 12.6511 14.8449 12.5991C16.0919 12.3359 16.6284 11.3856 17.098 10.5473C17.4729 9.8786 17.7994 9.30349 18.4214 9.08561C19.1927 8.81333 19.7963 9.07348 20.5617 9.40036C21.2123 9.73069 21.9263 9.91937 22.6561 9.95424C23.055 9.95402 23.4509 9.88644 23.8269 9.75452L23.8267 27.1092ZM24.2841 8.06266C23.8566 8.49914 23.2691 8.74479 22.6558 8.74346C22.0934 8.70404 21.5454 8.54959 21.0461 8.28965C20.1985 7.9266 19.2381 7.51203 18.0157 7.94458C16.9577 8.31672 16.4669 9.18535 16.0339 9.95388C15.5765 10.7679 15.2624 11.2702 14.5918 11.4126C13.9149 11.5579 13.165 11.3823 12.4577 11.1916C11.4994 10.9276 10.51 10.7913 9.51544 10.7861C9.41178 10.7861 9.31118 10.7861 9.20751 10.7892C8.69662 10.8238 8.18356 10.8048 7.6766 10.7322C7.43458 10.693 7.2002 10.617 6.98132 10.5067C6.74257 10.3793 6.5514 10.1699 6.31436 10.0468C6.08521 9.9526 5.82421 9.97318 5.61294 10.1023C5.43202 10.2314 5.32355 10.438 5.32028 10.6592V15.2287C5.32726 15.619 5.18846 15.9983 4.93073 16.2933C4.67299 16.5883 4.31422 16.7781 3.92381 16.8264C3.48843 16.8682 3.05522 16.7261 2.7309 16.4346C2.40661 16.1432 2.22089 15.7295 2.21958 15.2952V8.35904C2.22613 8.0508 2.30208 7.74778 2.44218 7.47245C2.70188 6.95279 3.16456 6.56135 3.72258 6.38917C4.10405 6.27869 4.50865 6.27458 4.89213 6.37747C5.12302 6.44137 5.36853 6.42989 5.59221 6.34476C5.80783 6.26309 5.99944 6.12901 6.14959 5.95507C6.61858 5.42631 7.26607 5.08623 7.97034 4.9985C8.31887 4.95236 8.6606 5.00695 9.00849 4.98572C9.41878 4.97272 9.81903 4.85575 10.1711 4.64607C10.6165 4.34606 11.0309 4.00359 11.4089 3.62323C11.8475 3.14603 12.3783 2.7611 12.9697 2.49143C14.1345 2.04347 15.3906 2.21914 16.238 2.44594C16.7877 2.61295 17.32 2.83303 17.8266 3.10273C18.3464 3.3735 18.8879 3.60116 19.4457 3.78353C20.4814 4.06903 21.5479 4.23062 22.6225 4.26463L22.7659 4.2707C23.3501 4.29106 23.9031 4.53692 24.3075 4.95582C24.7119 5.37476 24.9358 5.93364 24.9315 6.51396C24.9271 7.09405 24.6948 7.64975 24.2841 8.06266ZM29.1591 22.1073C29.158 22.6125 28.9552 23.0964 28.5951 23.4532C28.2351 23.8102 27.7471 24.0106 27.2384 24.011H25.0462V12.9564H27.2384C27.7469 12.9572 28.2346 13.1578 28.5945 13.5146C28.9543 13.8713 29.1573 14.355 29.159 14.8598L29.1591 22.1073Z"
                    fill="#2D7617"
                    stroke="#2D7617"
                    stroke-width="0.8"
                  />
                </svg> -->
              </div>
              <div class="label fs-13">
                {{ $t("alcohol") }}
              </div>
              <div class="check-icon flex-mid">
                <svg
                  width="19"
                  height="15"
                  viewBox="0 0 19 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                    stroke="white"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>

            <div
              id="buttonSmoking"
              :class="`disease-long-card ${
                form.behavior.smoking == true ? 'select' : ''
              }`"
              @click="form.behavior.smoking = !form.behavior.smoking"
            >
              <div class="icon">
                <img
                  src="@/assets/image/NewDesign/QuestionImage/behavior/smoking.png"
                  style="width: 4.2rem; height: 4.2rem"
                />
                <!-- <svg
                  width="35"
                  viewBox="0 0 40 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 25.6055C1 26.6726 1.42388 27.696 2.17844 28.4505C2.93277 29.2049 3.95641 29.629 5.02345 29.629H34.5979C35.038 29.629 35.4601 29.4539 35.7711 29.1429C36.0825 28.8319 36.2572 28.4097 36.2572 27.9697V23.2411C36.2572 22.801 36.0825 22.3791 35.7711 22.0678C35.4601 21.7568 35.038 21.582 34.5979 21.582H5.02345C3.95641 21.582 2.93269 22.0059 2.17844 22.7605C1.42383 23.5148 1 24.5384 1 25.6055ZM2.65901 25.6055C2.65901 24.9783 2.90812 24.377 3.35139 23.9335C3.79494 23.4902 4.39613 23.2411 5.02343 23.2411H10.5399V27.9697H5.02343C4.39615 27.9697 3.79491 27.7206 3.35139 27.2773C2.90812 26.8338 2.65901 26.2325 2.65901 25.6055ZM12.1991 23.2411H30.0351V27.9697H12.1991V23.2411ZM34.5977 27.9283H31.6943V23.2411H34.5977V27.9283Z"
                    fill="#2D7617"
                    stroke="#2D7617"
                    stroke-width="0.3"
                  />
                  <path
                    d="M28.5431 18.1378C28.5431 18.5958 28.9144 18.9673 29.3727 18.9673C29.8307 18.9673 30.2022 18.5958 30.2022 18.1378C30.2022 16.6859 30.8242 15.9808 31.6541 15.1099C32.4836 14.2387 33.5205 13.0773 33.5205 10.962C33.5205 8.84665 32.525 7.76805 31.6541 6.81411C30.7829 5.86017 30.2022 5.27947 30.2022 3.78623C30.1891 3.27324 30.2884 2.76341 30.4926 2.2927C30.6295 2.0893 30.6694 1.83584 30.6014 1.60032C30.5337 1.3648 30.3653 1.17124 30.1411 1.07171C29.9172 0.971885 29.6605 0.976514 29.4403 1.08415C29.2199 1.19178 29.0584 1.39113 28.9994 1.62926C28.693 2.30658 28.5373 3.04265 28.5431 3.78593C28.5431 5.90128 29.5387 6.97988 30.4096 7.93382C31.2808 8.88776 31.8615 9.46846 31.8615 10.9617C31.8615 12.4549 31.2394 13.1187 30.4096 13.9896C29.5801 14.8608 28.5431 16.0221 28.5431 18.1378Z"
                    fill="#2D7617"
                    stroke="#2D7617"
                    stroke-width="0.3"
                  />
                  <path
                    d="M34.2736 18.255C34.2736 18.713 34.6448 19.0845 35.1031 19.0845C35.5611 19.0845 35.9326 18.713 35.9326 18.255C35.9326 16.8031 36.5547 16.098 37.3845 15.2271C38.214 14.3559 39.251 13.1945 39.251 11.0792C39.251 8.96383 38.2554 7.88523 37.3845 6.93129C36.5133 5.97735 35.9326 5.39665 35.9326 3.90341C35.9196 3.39042 36.0188 2.88059 36.2231 2.40988C36.36 2.20648 36.3999 1.95302 36.3319 1.7175C36.2642 1.48199 36.0958 1.28842 35.8716 1.18889C35.6476 1.08907 35.391 1.0937 35.1708 1.20133C34.9503 1.30896 34.7889 1.50831 34.7299 1.74644C34.4235 2.42377 34.2678 3.15983 34.2736 3.90312C34.2736 6.01847 35.2692 7.09706 36.1401 8.051C37.0113 9.00494 37.592 9.58565 37.592 11.0789C37.592 12.5721 36.9699 13.2359 36.1401 14.1068C35.3106 14.978 34.2736 16.1393 34.2736 18.255Z"
                    fill="#2D7617"
                    stroke="#2D7617"
                    stroke-width="0.3"
                  />
                </svg> -->
              </div>
              <div class="label fs-13">
                {{ $t("smoking") }}
              </div>
              <div class="check-icon flex-mid">
                <svg
                  width="19"
                  height="15"
                  viewBox="0 0 19 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                    stroke="white"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>

            <div
              id="buttonAirPollution"
              :class="`disease-long-card ${
                form.behavior.airPollution == true ? 'select' : ''
              }`"
              @click="form.behavior.airPollution = !form.behavior.airPollution"
            >
              <div class="icon">
                <!-- <img src="@/assets/image/NewDesign/QuestionImage/behavior/airPollution.png" style="width:4.2rem;height: 4.2rem;"/> -->
                <svg
                  width="32"
                  height="33"
                  viewBox="0 0 32 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M26.3858 4.03937C24.0717 2.0929 20.6956 2.04674 18.3289 3.92927L15.5325 6.1532C14.962 6.60707 14.1843 6.70661 13.5167 6.41168C10.6183 5.13114 7.2668 6.81063 6.57887 9.88871L6.53372 10.0904C6.43864 10.5155 6.01502 10.7835 5.58714 10.689C5.15954 10.5947 4.88997 10.1733 4.98505 9.74825L5.0302 9.54653C5.93557 5.4957 10.3465 3.28495 14.1607 4.97031C14.2866 5.02602 14.4335 5.00727 14.5413 4.92146L17.3377 2.69753C20.2969 0.344227 24.5176 0.402018 27.4106 2.83536C30.3838 5.33628 29.3475 10.1225 25.6027 11.1864L21.8417 12.2547C21.4205 12.3743 20.9815 12.1319 20.8611 11.7132C20.7408 11.2944 20.9846 10.858 21.4059 10.7381L25.1671 9.6698C27.6918 8.95271 28.3903 5.72564 26.3859 4.03927L26.3858 4.03937ZM10.5174 14.6048C10.4916 14.1699 10.1163 13.8383 9.67891 13.8639C9.24175 13.8892 8.9079 14.2626 8.93366 14.6974L9.72698 28.1031C9.75275 28.5377 10.128 28.8696 10.5654 28.8439C11.0026 28.8183 11.3365 28.4453 11.3107 28.0104L10.5174 14.6048ZM12.4599 20.0877L19.2444 16.7154V18.872C19.2444 19.6929 20.1131 20.2265 20.8515 19.8595L27.1765 16.7153V27.2679C27.1765 27.7033 27.5316 28.0563 27.9698 28.0563C28.4077 28.0563 28.7631 27.7033 28.7631 27.2679V15.9495C28.7631 15.1286 27.8944 14.595 27.1557 14.9621L20.8307 18.1062V15.9496C20.8307 15.1287 19.962 14.5951 19.2234 14.9621L11.7505 18.6768C11.3587 18.8714 11.1999 19.3451 11.3956 19.7348C11.5916 20.1242 12.0681 20.2821 12.4598 20.0872L12.4599 20.0877ZM3.37968 11.4967C2.94173 11.4967 2.58664 11.8499 2.58664 12.2853C2.58664 12.7207 2.94173 13.074 3.37968 13.074H10.5187C10.957 13.074 11.3121 12.7207 11.3121 12.2853C11.3121 11.8499 10.957 11.4967 10.5187 11.4967H3.37968ZM4.21951 13.8639C4.65694 13.8893 4.99053 14.2626 4.96503 14.6975L4.17171 28.1031C4.14595 28.5377 3.77067 28.8696 3.33325 28.844C2.89582 28.8184 2.56223 28.4453 2.588 28.0105L3.38132 14.6048C3.40681 14.17 3.78235 13.8383 4.21951 13.8639ZM1.79332 30.4228C1.35536 30.4228 1 30.7761 1 31.2114C1 31.6468 1.35536 32.0001 1.79332 32.0001H30.3495C30.7875 32.0001 31.1429 31.6468 31.1429 31.2114C31.1429 30.7761 30.7875 30.4228 30.3495 30.4228H1.79332ZM12.8983 22.8524C12.8983 22.2428 13.3955 21.7485 14.009 21.7485H16.8646C17.3026 21.7485 17.6577 22.1015 17.6577 22.5372C17.6577 22.9725 17.3026 23.3256 16.8646 23.3256H14.4849V25.6913C14.4849 26.1269 14.1296 26.48 13.6916 26.48C13.2537 26.48 12.8983 26.1269 12.8983 25.6913V22.8524ZM21.9411 21.7485C21.3278 21.7485 20.8307 22.2428 20.8307 22.8524V25.6913C20.8307 26.1269 21.1858 26.48 21.624 26.48C22.0619 26.48 22.417 26.1269 22.417 25.6913V23.3256H24.7967C25.2349 23.3256 25.59 22.9725 25.59 22.5372C25.59 22.1015 25.2349 21.7485 24.7967 21.7485H21.9411Z"
                    fill="#2D7617"
                    stroke="#2D7617"
                    stroke-width="0.3"
                  />
                </svg>
              </div>
              <div class="label fs-13">
                {{ $t("airPollution") }}
              </div>
              <div class="check-icon flex-mid">
                <svg
                  width="19"
                  height="15"
                  viewBox="0 0 19 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                    stroke="white"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>

            <div
              id="buttonHealthCheckUp"
              :class="`disease-long-card ${
                form.behavior.healthCheck == true ? 'select' : ''
              }`"
              @click="
                form.behavior.healthCheck = !form.behavior.healthCheck;
                form.behavior.healthCheck
                  ? (form.behavior.nothealthCheck = false)
                  : '';
              "
            >
              <div class="icon">
                <img
                  src="@/assets/image/NewDesign/QuestionImage/behavior/healthCheck.png"
                  style="width: 4.2rem; height: 4.2rem"
                />
                <!-- <svg
                  width="25"
                  height="34"
                  viewBox="0 0 25 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.82818 33H23.1714C23.6272 33 24 32.6275 24 32.1722L23.9997 1.82782C23.9997 1.37248 23.6269 1 23.1711 1H1.82862C1.37283 1 1 1.37248 1 1.82782V32.1807C1 32.6274 1.37239 33 1.82818 33ZM9.22665 2.65564H15.7804V3.45848H9.22665V2.65564ZM2.65623 2.65564H7.56942V4.2863C7.56942 4.74164 7.94225 5.11412 8.39803 5.11412H16.6089C17.0647 5.11412 17.4375 4.74164 17.4375 4.2863V2.65564H22.3507V31.3526H2.65652L2.65623 2.65564Z"
                    fill="#2D7617"
                    stroke="#2D7617"
                    stroke-width="0.4"
                  />
                  <path
                    d="M20.1434 16.0736H18.9008L17.4611 13.9163C17.2813 13.652 16.9729 13.5069 16.6472 13.5412C16.3302 13.5752 16.0559 13.7884 15.9446 14.0868L14.2138 18.6913L11.6091 11.5627C11.4892 11.2215 11.1636 11 10.8038 11H10.7952C10.4268 11.0086 10.1098 11.2387 9.98984 11.5798L7.99332 17.5316L7.26489 16.4488C7.10222 16.2101 6.83656 16.0651 6.55368 16.0651H4.85696C4.38559 16.0651 4 16.4488 4 16.9178C4 17.3869 4.38559 17.7706 4.85696 17.7706H6.0995L7.54746 19.9279C7.72734 20.2008 8.05297 20.3455 8.36997 20.303C8.6956 20.2605 8.96987 20.0386 9.07257 19.7317L10.8378 14.4452L13.3912 21.4373C13.5111 21.7699 13.8368 22 14.1965 22C14.5563 22 14.8733 21.7782 15.0019 21.4459L16.9639 16.2444L17.7351 17.3955C17.8978 17.6342 18.1634 17.7792 18.4463 17.7792H20.143C20.6144 17.7792 21 17.3955 21 16.9264C21.0003 16.4574 20.6148 16.0736 20.1434 16.0736Z"
                    fill="#2D7617"
                    stroke="#2D7617"
                    stroke-width="0.4"
                  />
                </svg> -->
              </div>
              <div class="label fs-13">
                {{ $t("healthcheck") }}
              </div>
              <div class="check-icon flex-mid">
                <svg
                  width="19"
                  height="15"
                  viewBox="0 0 19 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                    stroke="white"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
            <div
              id="buttonNoHealthCheckUp"
              :class="`disease-long-card ${
                form.behavior.nothealthCheck == true ? 'select' : ''
              }`"
              @click="
                form.behavior.nothealthCheck = !form.behavior.nothealthCheck;
                form.behavior.nothealthCheck
                  ? (form.behavior.healthCheck = false)
                  : '';
              "
            >
              <div class="icon">
                <img
                  src="@/assets/image/NewDesign/QuestionImage/behavior/noHealthCheck.png"
                  style="width: 4.2rem; height: 4.2rem"
                />
                <!-- <svg
                  width="39"
                  height="36"
                  viewBox="0 0 39 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.39136 33.6883H29.6448C30.0773 33.6883 30.4311 33.3345 30.4311 32.902L30.4308 4.07928C30.4308 3.64677 30.077 3.29297 29.6445 3.29297H9.39178C8.95927 3.29297 8.60547 3.64677 8.60547 4.07928V32.9101C8.60547 33.3344 8.95885 33.6883 9.39136 33.6883ZM16.4121 4.86559H22.6311V5.62817H16.4121V4.86559ZM10.1771 4.86559H14.8394V6.41448C14.8394 6.84699 15.1932 7.20078 15.6257 7.20078H23.4174C23.8499 7.20078 24.2037 6.84699 24.2037 6.41448V4.86559H28.866V32.1235H10.1774L10.1771 4.86559Z"
                    fill="#2D7617"
                    stroke="#2D7617"
                    stroke-width="0.4"
                  />
                  <path
                    d="M26.5312 18.0922H25.3911L24.0701 16.1031C23.9051 15.8593 23.622 15.7256 23.3232 15.7572C23.0323 15.7885 22.7808 15.9852 22.6786 16.2602L21.0905 20.5058L18.7005 13.9329C18.5905 13.6184 18.2916 13.4141 17.9615 13.4141H17.9536C17.6156 13.422 17.3248 13.6342 17.2148 13.9487L15.3829 19.4366L14.7145 18.4381C14.5652 18.218 14.3215 18.0843 14.0619 18.0843H12.5051C12.0725 18.0843 11.7188 18.4381 11.7188 18.8706C11.7188 19.3031 12.0725 19.6569 12.5051 19.6569H13.6452L14.9738 21.646C15.1388 21.8977 15.4376 22.0311 15.7285 21.9919C16.0272 21.9527 16.2789 21.7481 16.3731 21.4652L17.9929 16.5907L20.3356 23.0378C20.4457 23.3445 20.7444 23.5566 21.0746 23.5566C21.4047 23.5566 21.6957 23.3521 21.8136 23.0457L23.6138 18.2497L24.3215 19.3111C24.4708 19.5311 24.7145 19.6649 24.9741 19.6649H26.5308C26.9633 19.6649 27.3172 19.3111 27.3172 18.8785C27.3175 18.446 26.9637 18.0922 26.5312 18.0922Z"
                    fill="#2D7617"
                    stroke="#2D7617"
                    stroke-width="0.4"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.1574 0.381308C38.5923 0.858291 38.5582 1.59752 38.0812 2.03241L1.95621 34.9699C1.47922 35.4048 0.74 35.3707 0.305103 34.8937C-0.129793 34.4167 -0.0956756 33.6775 0.381308 33.2426L36.5063 0.305103C36.9833 -0.129793 37.7225 -0.0956756 38.1574 0.381308Z"
                    fill="#2D7617"
                  />
                </svg> -->
              </div>
              <div class="label fs-13">
                {{ $t("nothealthcheck") }}
              </div>
              <div class="check-icon flex-mid">
                <svg
                  width="19"
                  height="15"
                  viewBox="0 0 19 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                    stroke="white"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="body mt-36">
          <div
            :class="`behavior-card flex-mid ${
              form.behavior.snoring ? 'select' : ''
            }`"
            @click="form.behavior.snoring = !form.behavior.snoring"
          >
            <div class="content">
              <div class="icon flex-mid">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22.2841 14.5681C21.2843 14.8711 20.2237 15.0341 19.125 15.0341C13.1189 15.0341 8.25 10.1652 8.25 4.15906C8.25 3.06037 8.41293 1.99974 8.71594 1C4.25051 2.35344 1 6.50165 1 11.4091C1 17.4152 5.8689 22.2841 11.875 22.2841C16.7824 22.2841 20.9306 19.0336 22.2841 14.5681Z"
                    stroke="#206B5E"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div class="label">{{ $t("snoring") }}</div>
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div
            :class="`behavior-card flex-mid ${
              form.behavior.alcohol ? 'select' : ''
            }`"
            @click="form.behavior.alcohol = !form.behavior.alcohol"
          >
            <div class="content">
              <div class="icon flex-mid">
                <svg
                  width="27"
                  height="29"
                  viewBox="0 0 27 29"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.3041 13.0405C10.0018 13.0405 9.75677 13.2678 9.75677 13.5481V21.2897C9.75677 21.57 10.0018 21.7973 10.3041 21.7973C10.6063 21.7973 10.8514 21.57 10.8514 21.2897V13.5481C10.8514 13.2678 10.6063 13.0405 10.3041 13.0405Z"
                    fill="#206B5E"
                    stroke="#206B5E"
                    stroke-width="0.8"
                  />
                  <path
                    d="M16.5067 13.0405C16.2045 13.0405 15.9594 13.2678 15.9594 13.5481V21.2897C15.9594 21.57 16.2045 21.7973 16.5067 21.7973C16.8092 21.7973 17.054 21.57 17.054 21.2897V13.5481C17.054 13.2678 16.809 13.0405 16.5067 13.0405Z"
                    fill="#206B5E"
                    stroke="#206B5E"
                    stroke-width="0.8"
                  />
                  <path
                    d="M23.8107 10.3416H21.9049V7.966C21.9393 7.937 21.9685 7.90555 22.0003 7.87391C22.5507 7.31892 22.8612 6.57264 22.8655 5.79392C22.8698 5.01505 22.5676 4.26554 22.0233 3.70453C21.4789 3.14371 20.7356 2.81584 19.9515 2.79101L19.8427 2.78574C18.9975 2.7622 18.1581 2.63678 17.3433 2.41212C16.9141 2.27031 16.4973 2.09348 16.0976 1.88331C15.5955 1.61986 15.0692 1.40479 14.5257 1.24155C13.3803 0.895984 12.1539 0.921785 11.0245 1.31518C10.3777 1.59558 9.79656 2.00573 9.31746 2.52002C9.0378 2.80382 8.73064 3.05939 8.40031 3.28308C8.10813 3.41358 7.78483 3.4601 7.46723 3.41716L7.38773 3.41452H7.38792C6.44061 3.39776 5.52711 3.76329 4.8564 4.4275C4.78222 4.4985 4.71335 4.57213 4.64694 4.64858L4.64713 4.64839C4.63347 4.64331 4.61924 4.63992 4.60482 4.63785C4.37753 4.58173 4.14436 4.55348 3.91022 4.55367C3.13878 4.55499 2.39926 4.85969 1.85377 5.40109C1.30832 5.94267 1.00131 6.67676 1 7.44246C1 7.50028 1.00266 7.56091 1.00531 7.61609L1 7.62137V13.4277V13.4275C1.00057 14.01 1.21534 14.5723 1.60392 15.0086C1.99248 15.4451 2.52826 15.7257 3.11057 15.7979C3.69282 15.8702 4.28174 15.7289 4.76651 15.4007V23.6985C4.76784 24.8389 5.22489 25.9323 6.0373 26.7387C6.84973 27.545 7.95126 27.9987 9.10008 28H17.5712C18.72 27.9987 19.8215 27.545 20.634 26.7387C21.4464 25.9323 21.9035 24.8389 21.9048 23.6985V22.0569H23.8106C24.534 22.0567 25.228 21.7716 25.7399 21.2639C26.2516 20.7564 26.5396 20.0679 26.5405 19.3499V13.0489C26.5392 12.3308 26.251 11.6425 25.7393 11.135C25.2276 10.6277 24.534 10.3422 23.8106 10.3417L23.8107 10.3416ZM20.8447 23.6985C20.8438 24.56 20.4987 25.3858 19.8849 25.995C19.2711 26.604 18.4391 26.9468 17.5713 26.9477H9.10023C8.23243 26.9468 7.40047 26.604 6.78669 25.995C6.17291 25.3858 5.82782 24.56 5.82685 23.6985V10.2524C6.60358 10.6076 7.45696 10.5839 8.16734 10.563C9.01674 10.5434 9.86429 10.6488 10.6825 10.8759C11.2254 11.0403 11.7879 11.1324 12.3552 11.1496C12.5838 11.1511 12.8123 11.129 13.0363 11.0838C14.1204 10.855 14.5868 10.0289 14.995 9.3001C15.321 8.71874 15.6048 8.21877 16.1456 8.02935C16.8161 7.79263 17.3408 8.0188 18.0062 8.30298C18.5718 8.59016 19.1926 8.75419 19.827 8.78451C20.1739 8.78432 20.518 8.72556 20.8449 8.61088L20.8447 23.6985ZM21.2424 7.14003C20.8707 7.51949 20.36 7.73305 19.8268 7.73189C19.3379 7.69762 18.8615 7.56335 18.4274 7.33737C17.6905 7.02175 16.8555 6.66133 15.7929 7.03738C14.8731 7.36091 14.4464 8.11606 14.0699 8.78419C13.6723 9.4919 13.3992 9.92858 12.8163 10.0523C12.2277 10.1787 11.5758 10.026 10.9609 9.86025C10.1279 9.63069 9.26763 9.51224 8.40303 9.50772C8.31291 9.50772 8.22545 9.50772 8.13533 9.51036C7.69118 9.54049 7.24513 9.52392 6.80441 9.46083C6.594 9.42675 6.39024 9.36065 6.19995 9.2648C5.99239 9.15406 5.82619 8.97196 5.62012 8.865C5.42091 8.78308 5.194 8.80097 5.01033 8.91321C4.85304 9.02544 4.75875 9.2051 4.7559 9.39737V13.3699C4.76197 13.7093 4.6413 14.039 4.41724 14.2955C4.19317 14.552 3.88126 14.7169 3.54186 14.7589C3.16335 14.7953 2.78674 14.6717 2.50479 14.4183C2.22285 14.165 2.0614 13.8053 2.06026 13.4277V7.39769C2.06595 7.12972 2.13198 6.86628 2.25378 6.62692C2.47956 6.17515 2.88179 5.83484 3.36691 5.68515C3.69855 5.58911 4.05029 5.58554 4.38368 5.67499C4.58441 5.73054 4.79785 5.72056 4.99231 5.64655C5.17976 5.57555 5.34634 5.45899 5.47688 5.30777C5.8846 4.84808 6.4475 4.55243 7.05978 4.47616C7.36277 4.43605 7.65986 4.4835 7.96231 4.46505C8.31899 4.45375 8.66696 4.35205 8.973 4.16977C9.36024 3.90894 9.72054 3.61121 10.0491 3.28055C10.4305 2.86568 10.8919 2.53104 11.4061 2.29659C12.4187 1.90716 13.5107 2.05988 14.2474 2.25705H14.2476C14.7255 2.40224 15.1881 2.59357 15.6285 2.82804C16.0804 3.06343 16.5511 3.26136 17.036 3.4199C17.9365 3.6681 18.8637 3.80859 19.7979 3.83816L19.9225 3.84343H19.9223C20.4302 3.86113 20.9112 4.07487 21.2628 4.43906C21.6143 4.80326 21.809 5.28913 21.8052 5.79364C21.8014 6.29796 21.5995 6.78097 21.2425 7.13993L21.2424 7.14003ZM25.4805 19.35C25.4796 19.7892 25.3033 20.2099 24.9903 20.52C24.6772 20.8304 24.253 21.0046 23.8107 21.005H21.9049V11.3944H23.8107C24.2528 11.3952 24.6768 11.5696 24.9897 11.8797C25.3025 12.1899 25.479 12.6104 25.4805 13.0492L25.4805 19.35Z"
                    fill="#206B5E"
                    stroke="#206B5E"
                    stroke-width="0.8"
                  />
                </svg>
              </div>
              <div class="label">{{ $t("alcohol") }}</div>
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
         <div
            :class="`behavior-card flex-mid ${
              form.behavior.exercise ? 'select' : ''
            }`"
            @click="form.behavior.exercise = !form.behavior.exercise"
          >
            <div class="content">
              <div class="icon flex-mid">
                <svg
                  width="34"
                  height="16"
                  viewBox="0 0 34 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M31.7202 4.18166H30.4401V3.54538C30.4401 2.14526 29.288 1 27.8802 1H25.3202C23.9121 1 22.7603 2.14553 22.7603 3.54538V5.45448H11.2402V3.54538C11.2402 2.14526 10.0882 1 8.68032 1H6.12039C4.71227 1 3.56047 2.14553 3.56047 3.54538V4.18166H2.2801C1.57614 4.18166 1 4.75428 1 5.45448V10.5455C1 11.2455 1.57589 11.8183 2.2801 11.8183H3.5602V12.4546C3.5602 13.8547 4.71227 15 6.12012 15H8.68004C10.0882 15 11.24 13.8545 11.24 12.4546V10.5455H22.76V12.4546C22.76 13.8547 23.9121 15 25.32 15H27.8799C29.288 15 30.4398 13.8545 30.4398 12.4546V11.8183H31.7199C32.4239 11.8183 33 11.2457 33 10.5455V5.45448C33.0003 4.75425 32.4244 4.18166 31.7205 4.18166H31.7202ZM2.27955 10.5452V5.45421H3.55965V10.5452H2.27955ZM9.95959 12.4543C9.95959 13.1543 9.3837 13.7272 8.6795 13.7272H6.11957C5.41561 13.7272 4.83947 13.1546 4.83947 12.4543V3.54497C4.83947 2.84501 5.41537 2.27214 6.11957 2.27214H8.6795C9.38345 2.27214 9.95959 2.84477 9.95959 3.54497V12.4543ZM11.2397 9.27269V6.72731H22.7598V9.27269H11.2397ZM29.1596 12.4543C29.1596 13.1543 28.5837 13.7272 27.8795 13.7272H25.3195C24.6156 13.7272 24.0394 13.1546 24.0394 12.4543V3.54497C24.0394 2.84501 24.6153 2.27214 25.3195 2.27214H27.8795C28.5834 2.27214 29.1596 2.84477 29.1596 3.54497V12.4543ZM30.4397 10.5452V5.45421H31.7198V10.5452H30.4397Z"
                    fill="#206B5E"
                    stroke="#206B5E"
                    stroke-width="0.3"
                  />
                </svg>
              </div>
              <div class="label">ออกกำลังกาย มากกว่า 3 ครั้ง ต่อสัปดาห์</div>
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div
            :class="`behavior-card flex-mid ${
              form.behavior.healthCheck ? 'select' : ''
            }`"
            @click="form.behavior.healthCheck = !form.behavior.healthCheck"
          >
            <div class="content">
              <div class="icon flex-mid">
                <svg
                  width="22"
                  height="30"
                  viewBox="0 0 22 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.73967 29.6074H20.8017C21.2087 29.6074 21.5417 29.2744 21.5417 28.8673L21.5415 1.74005C21.5415 1.33299 21.2085 1 20.8014 1H1.74005C1.33299 1 1 1.33299 1 1.74005V28.8749C1 29.2743 1.33299 29.6073 1.74005 29.6073L1.73967 29.6074ZM8.34738 2.48011H14.2006V3.19783H8.34738V2.48011ZM2.47921 2.48011H6.86727V3.93789C6.86727 4.34495 7.20025 4.67794 7.60732 4.67794H14.9406C15.3477 4.67794 15.6807 4.34495 15.6807 3.93789V2.48011H20.0687V28.1346H2.47947L2.47921 2.48011Z"
                    fill="#206B5E"
                    stroke="#206B5E"
                    stroke-width="0.4"
                  />
                  <path
                    d="M17.8708 14.9268H16.7978L15.5545 13.0548C15.3992 12.8253 15.1328 12.6995 14.8516 12.7292C14.5779 12.7587 14.341 12.9438 14.2449 13.2027L12.7502 17.1985L10.5008 11.0123C10.3972 10.7162 10.116 10.5239 9.80532 10.5239H9.79789C9.47977 10.5314 9.206 10.731 9.10242 11.0271L7.37825 16.1921L6.7492 15.2524C6.60872 15.0453 6.3793 14.9194 6.13501 14.9194H4.66974C4.26267 14.9194 3.92969 15.2524 3.92969 15.6595C3.92969 16.0666 4.26267 16.3995 4.66974 16.3995H5.74278L6.99322 18.2716C7.14856 18.5085 7.42977 18.6341 7.70353 18.5972C7.98473 18.5603 8.22159 18.3678 8.31028 18.1014L9.83472 13.5137L12.0398 19.5815C12.1434 19.8702 12.4246 20.0699 12.7353 20.0699C13.0459 20.0699 13.3197 19.8773 13.4307 19.589L15.1251 15.0751L15.7911 16.074C15.9316 16.2811 16.161 16.407 16.4053 16.407H17.8706C18.2776 16.407 18.6106 16.074 18.6106 15.667C18.6109 15.2599 18.2779 14.9269 17.8708 14.9269L17.8708 14.9268Z"
                    fill="#206B5E"
                    stroke="#206B5E"
                    stroke-width="0.4"
                  />
                </svg>
              </div>
              <div class="label">{{ $t("healthcheck") }}</div>
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div
            :class="`behavior-card flex-mid ${
              form.behavior.smoking ? 'select' : ''
            }`"
            @click="form.behavior.smoking = !form.behavior.smoking"
          >
            <div class="content">
              <div class="icon flex-mid">
                <svg
                  width="38"
                  height="29"
                  viewBox="0 0 38 29"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 24.1511C1 25.1554 1.39894 26.1186 2.10912 26.8288C2.81908 27.5387 3.7825 27.9379 4.78678 27.9379H32.6215C33.0357 27.9379 33.4331 27.7731 33.7258 27.4804C34.0188 27.1877 34.1833 26.7904 34.1833 26.3762V21.9257C34.1833 21.5115 34.0188 21.1145 33.7258 20.8215C33.433 20.5287 33.0357 20.3643 32.6215 20.3643H4.78678C3.7825 20.3643 2.81901 20.7632 2.10912 21.4734C1.39889 22.1833 1 23.1468 1 24.151V24.1511ZM2.56142 24.1511C2.56142 23.5607 2.79588 22.9949 3.21307 22.5774C3.63053 22.1602 4.19636 21.9258 4.78676 21.9258H9.97872V26.3762H4.78676C4.19637 26.3762 3.63051 26.1417 3.21307 25.7246C2.79588 25.3071 2.56142 24.7413 2.56142 24.1512V24.1511ZM11.5404 21.9258H28.3271V26.3762H11.5404V21.9258ZM32.6214 26.3372H29.8887V21.9258H32.6214V26.3372Z"
                    fill="#206B5E"
                    stroke="#206B5E"
                    stroke-width="0.3"
                  />
                  <path
                    d="M26.9218 17.1238C26.9218 17.5549 27.2712 17.9045 27.7025 17.9045C28.1336 17.9045 28.4832 17.5549 28.4832 17.1238C28.4832 15.7573 29.0687 15.0937 29.8497 14.274C30.6304 13.4541 31.6064 12.3611 31.6064 10.3701C31.6064 8.37922 30.6694 7.36407 29.8497 6.46624C29.0298 5.56842 28.4832 5.02187 28.4832 3.61647V3.6162C28.471 3.13338 28.5644 2.65382 28.7566 2.2108C28.8854 2.01936 28.923 1.78081 28.859 1.55915C28.7953 1.33748 28.6368 1.1553 28.4258 1.06163C28.215 0.967679 27.9735 0.972036 27.7662 1.07334C27.5587 1.17464 27.4068 1.36226 27.3512 1.58638C27.0628 2.22387 26.9163 2.91663 26.9218 3.6162C26.9218 5.60711 27.8588 6.62226 28.6785 7.52009C29.4984 8.41791 30.045 8.96446 30.045 10.3699C30.045 11.7753 29.4595 12.4 28.6785 13.2196C27.8978 14.0396 26.9218 15.1326 26.9218 17.1238L26.9218 17.1238Z"
                    fill="#206B5E"
                    stroke="#206B5E"
                    stroke-width="0.3"
                  />
                  <path
                    d="M32.3154 17.2337C32.3154 17.6647 32.6648 18.0144 33.0961 18.0144C33.5272 18.0144 33.8768 17.6647 33.8768 17.2337C33.8768 15.8672 34.4623 15.2036 35.2433 14.3839C36.024 13.5639 37 12.4709 37 10.48C37 8.48908 36.063 7.47393 35.2433 6.57611C34.4234 5.67828 33.8768 5.13174 33.8768 3.72633V3.72606C33.8646 3.24325 33.958 2.76368 34.1502 2.32066C34.279 2.12922 34.3166 1.89067 34.2526 1.66901C34.1889 1.44735 34.0304 1.26517 33.8194 1.17149C33.6086 1.07754 33.3671 1.0819 33.1598 1.1832C32.9523 1.2845 32.8004 1.47213 32.7448 1.69624C32.4565 2.33373 32.3099 3.0265 32.3154 3.72606C32.3154 5.71697 33.2524 6.73213 34.0721 7.62995C34.892 8.52778 35.4386 9.07432 35.4386 10.4797C35.4386 11.8851 34.8531 12.5098 34.0721 13.3295C33.2914 14.1495 32.3154 15.2425 32.3154 17.2337L32.3154 17.2337Z"
                    fill="#206B5E"
                    stroke="#206B5E"
                    stroke-width="0.3"
                  />
                </svg>
              </div>
              <div class="label">{{ $t("smoking") }}</div>
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
        </div> -->
      </div>
      <div class="footer-nav">
        <div class="footer-btn-next">
          <div
            id="next-5"
            @click="nextBehavior"
            style="width: 14rem"
            class="btn-48 btn-question btn mx-auto"
          >
            {{ $t("next") }}
          </div>
        </div>
      </div>
    </div>
    <div
      v-else-if="step == 'question_disease'"
      class="center disease-container"
    >
      <div class="form-container" style="padding-bottom: 10rem">
        <div v-if="lang == 'th'" class="question-title body-max-width">
          <p>
            <span style="color: #00a59c">{{ $t("you") }}</span
            >{{ $t("disease") }}
          </p>
        </div>
        <div v-else class="question-title body-max-width">
          <p>
            {{ $t("do") }}<span style="color: #00a59c">{{ $t("you") }}</span
            >{{ $t("disease") }}
          </p>
        </div>
        <div
          class="fs-14 fw-500 fc-2D7617 mt-6 mx-auto"
          style="width: 80%; color: #f57f29"
        >
          {{ $t("morethanonedisease2") }}
        </div>
        <div class="mt-20">
          <img
            src="@/assets/image/NewDesign/QuestionImage/underlyingDisease.png"
          />
        </div>

        <div class="disease-details-box">
          <div class="body">
            <!-- cancer -->
            <div
              id="buttonCancer"
              :class="`disease-long-card ${
                form.disease.cancer ? 'select' : ''
              }`"
              @click="
                form.disease.cancer = !form.disease.cancer;
                form.disease.none = false;
              "
            >
              <div class="icon">
                <img
                  src="@/assets/image/NewDesign/QuestionImage/diseaseIcon/cancer.png"
                />
              </div>
              <div class="label">
                {{ $t("cancer") }}
              </div>
              <div class="check-icon flex-mid">
                <svg
                  width="19"
                  height="15"
                  viewBox="0 0 19 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                    stroke="white"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
            <!-- stroke -->
            <div
              id="buttonStroke"
              :class="`disease-long-card ${
                form.disease.stroke ? 'select' : ''
              }`"
              @click="
                form.disease.stroke = !form.disease.stroke;
                form.disease.none = false;
              "
            >
              <div class="icon">
                <img
                  src="@/assets/image/NewDesign/QuestionImage/diseaseIcon/stroke.png"
                />
              </div>
              <div class="label">
                {{ $t("stroke") }}
              </div>
              <div class="check-icon flex-mid">
                <svg
                  width="19"
                  height="15"
                  viewBox="0 0 19 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                    stroke="white"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
            <!-- diabetes -->
            <div
              id="buttonDiabete"
              :class="`disease-long-card ${
                form.disease.diabetes ? 'select' : ''
              }`"
              @click="
                form.disease.diabetes = !form.disease.diabetes;
                form.disease.none = false;
              "
            >
              <div class="icon">
                <img
                  src="@/assets/image/NewDesign/QuestionImage/diseaseIcon/diabetes.png"
                />
              </div>
              <div class="label">
                {{ $t("diabete") }}
              </div>
              <div class="check-icon flex-mid">
                <svg
                  width="19"
                  height="15"
                  viewBox="0 0 19 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                    stroke="white"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
            <!-- metabolic syndrom -->
            <div
              id="buttonMetabolic"
              :class="`disease-long-card ${
                form.disease.metabolic ? 'select' : ''
              }`"
              @click="
                form.disease.metabolic = !form.disease.metabolic;
                form.disease.none = false;
              "
            >
              <div class="icon">
                <img
                  src="@/assets/image/NewDesign/QuestionImage/diseaseIcon/metabolic.png"
                />
              </div>
              <div class="label">
                {{ $t("metabolic") }}
              </div>
              <div class="check-icon flex-mid">
                <svg
                  width="19"
                  height="15"
                  viewBox="0 0 19 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                    stroke="white"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
            <!-- hypertension -->
            <div
              id="buttonHypertension"
              :class="`disease-long-card ${
                form.disease.hypertension ? 'select' : ''
              }`"
              @click="
                form.disease.hypertension = !form.disease.hypertension;
                form.disease.none = false;
              "
            >
              <div class="icon">
                <img
                  src="@/assets/image/NewDesign/QuestionImage/diseaseIcon/hypertension.png"
                />
              </div>
              <div class="label">
                {{ $t("hypertension") }}
              </div>
              <div class="check-icon flex-mid">
                <svg
                  width="19"
                  height="15"
                  viewBox="0 0 19 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                    stroke="white"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
            <!-- No undelying disease / none -->
            <div
              id="buttonNone"
              :class="`disease-long-card ${form.disease.none ? 'select' : ''}`"
              @click="
                form.disease.none = !form.disease.none;
                form.disease.cancer = false;
                form.disease.stroke = false;
                form.disease.diabetes = false;
                form.disease.metabolic = false;
                form.disease.hypertension = false;
                form.disease.cardiovascular = false;
                form.disease.kidney = false;
                form.disease.other = false;
              "
            >
              <div class="icon">
                <img
                  src="@/assets/image/NewDesign/QuestionImage/diseaseIcon/noUnderlying.png"
                />
              </div>
              <div class="label">
                {{ $t("none") }}
              </div>
              <div class="check-icon flex-mid">
                <svg
                  width="19"
                  height="15"
                  viewBox="0 0 19 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                    stroke="white"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
            <!-- cardiovascular -->
            <div
              id="buttonCardiovascular"
              :class="`disease-long-card ${
                form.disease.cardiovascular ? 'select' : ''
              }`"
              @click="
                form.disease.cardiovascular = !form.disease.cardiovascular;
                form.disease.none = false;
              "
            >
              <div class="icon">
                <img
                  src="@/assets/image/NewDesign/QuestionImage/diseaseIcon/cardiovascular.png"
                />
              </div>
              <div class="label">
                {{ $t("cvd") }}
              </div>
              <div class="check-icon flex-mid">
                <svg
                  width="19"
                  height="15"
                  viewBox="0 0 19 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                    stroke="white"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
            <!-- other disease -->
            <div
              id="buttonOther"
              :class="`disease-long-card ${form.disease.other ? 'select' : ''}`"
              @click="
                form.disease.other = !form.disease.other;
                form.disease.none = false;
              "
            >
              <div class="icon">
                <img
                  src="@/assets/image/NewDesign/QuestionImage/diseaseIcon/other.png"
                />
              </div>
              <div class="label">
                {{ $t("other") }}
              </div>
              <div class="check-icon flex-mid">
                <svg
                  width="19"
                  height="15"
                  viewBox="0 0 19 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                    stroke="white"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>

            <!-- kidney -->
            <div
              id="buttonKidney"
              :class="`disease-long-card ${
                form.disease.kidney ? 'select' : ''
              }`"
              @click="
                form.disease.kidney = !form.disease.kidney;
                form.disease.none = false;
              "
            >
              <div class="icon">
                <img
                  src="@/assets/image/NewDesign/QuestionImage/diseaseIcon/kidney.png"
                />
              </div>
              <div class="label">
                {{ $t("kidney") }}
              </div>
              <div class="check-icon flex-mid">
                <svg
                  width="19"
                  height="15"
                  viewBox="0 0 19 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                    stroke="white"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>

            <!-- other fill -->
            <div
              id="fillOtherData"
              v-if="form.disease.other"
              :class="`disease-long-card select ${
                otherClickNext ? 'error' : ''
              }`"
            >
              <div class="none-41 m-10 ml-0">
                <el-input
                  v-model="form.disease.otherData"
                  :placeholder="$t('pleaseFillDisease')"
                />
              </div>
            </div>
          </div>
          <!-- <div
            v-if="otherClickNext"
            class="mx-auto"
            style="margin-left: 0; font-size: 12px; color: red"
          >
            {{ $t("pleaseFillDiseaseCompletely") }}
          </div> -->
          <div
            class="fs-14 fw-500 fc-404040 body-max-width"
            style="max-width: 600px; margin: auto; margin-top: 20px"
          >
            {{ $t("suggestedisease") }}
          </div>
        </div>
      </div>
      <div class="footer-nav">
        <div class="footer-btn-next">
          <div
            id="next-6"
            @click="nextDisease"
            style="width: 14rem"
            class="btn-48 btn-question btn mx-auto"
            :class="{
              disable: formValidate.question_disease,
              disable:
                !form.disease.none &&
                !form.disease.cancer &&
                !form.disease.stroke &&
                !form.disease.diabetes &&
                !form.disease.metabolic &&
                !form.disease.hypertension &&
                !form.disease.cardiovascular &&
                !form.disease.kidney &&
                !form.disease.other,
            }"
          >
            {{ $t("next") }}
          </div>
        </div>
      </div>
    </div>
    <div
      v-else-if="step == 'question_disease_family'"
      class="center disease-container family"
    >
      <!-- class="center disease-family-container" -->
      <div class="form-container">
        <div v-if="lang == 'th'" :class="`question-title body-max-width`">
          <p>
            <span style="color: #00a59c">{{ $t("family") }}</span>
            {{ $t("famdisease") }}
          </p>
        </div>
        <div v-else :class="`question-title body-max-width`">
          <p>
            {{ $t("do") }}<span style="color: #00a59c">{{ $t("family") }}</span>
            {{ $t("famdisease") }}
          </p>
        </div>
        <div
          class="fs-14 fw-500 fc-2D7617 mt-6 body-max-width"
          style="color: #f57f29; margin: 0 2rem 0 2rem"
        >
          {{ $t("morethanonedisease2") }}
        </div>
        <div class="mt-20">
          <img
            src="@/assets/image/NewDesign/QuestionImage/underlyingDiseaseFamily.png"
          />
        </div>
        <div class="body mt-4 pt-34">
          <!-- family cancer  -->
          <div
            id="buttonCancerFamily"
            :class="`disease-long-card ${
              form.diseaseFamily.cancer ? 'select' : ''
            }`"
            @click="
              form.diseaseFamily.cancer = !form.diseaseFamily.cancer;
              form.diseaseFamily.none = false;
            "
          >
            <div class="icon">
              <img
                src="@/assets/image/NewDesign/QuestionImage/diseaseIcon/cancer.png"
              />
            </div>
            <div class="label">
              {{ $t("cancer") }}
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <!-- family stroke -->
          <div
            id="buttonStrokeFamily"
            :class="`disease-long-card ${
              form.diseaseFamily.stroke ? 'select' : ''
            }`"
            @click="
              form.diseaseFamily.stroke = !form.diseaseFamily.stroke;
              form.diseaseFamily.none = false;
            "
          >
            <div class="icon">
              <img
                src="@/assets/image/NewDesign/QuestionImage/diseaseIcon/stroke.png"
              />
            </div>
            <div class="label">
              {{ $t("stroke") }}
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <!-- family diabetes -->
          <div
            id="buttonDiabeteFamily"
            :class="`disease-long-card ${
              form.diseaseFamily.diabetes ? 'select' : ''
            }`"
            @click="
              form.diseaseFamily.diabetes = !form.diseaseFamily.diabetes;
              form.diseaseFamily.none = false;
            "
          >
            <div class="icon">
              <img
                src="@/assets/image/NewDesign/QuestionImage/diseaseIcon/diabetes.png"
              />
            </div>
            <div class="label">
              {{ $t("diabete") }}
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <!-- family metabolic -->
          <div
            id="buttonMetabolicFamily"
            :class="`disease-long-card ${
              form.diseaseFamily.metabolic ? 'select' : ''
            }`"
            @click="
              form.diseaseFamily.metabolic = !form.diseaseFamily.metabolic;
              form.diseaseFamily.none = false;
            "
          >
            <div class="icon">
              <img
                src="@/assets/image/NewDesign/QuestionImage/diseaseIcon/metabolic.png"
              />
            </div>
            <div class="label">
              {{ $t("metabolic") }}
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <!-- family hypertension -->
          <div
            id="buttonHypertensionFamily"
            :class="`disease-long-card ${
              form.diseaseFamily.hypertension ? 'select' : ''
            }`"
            @click="
              form.diseaseFamily.hypertension =
                !form.diseaseFamily.hypertension;
              form.diseaseFamily.none = false;
            "
          >
            <div class="icon">
              <img
                src="@/assets/image/NewDesign/QuestionImage/diseaseIcon/hypertension.png"
              />
            </div>
            <div class="label">
              {{ $t("hypertension") }}
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <!-- family No undelying disease / none -->
          <div
            id="buttonNone"
            :class="`disease-long-card ${
              form.diseaseFamily.none ? 'select' : ''
            }`"
            @click="
              form.diseaseFamily.none = !form.diseaseFamily.none;
              form.diseaseFamily.cancer = false;
              form.diseaseFamily.stroke = false;
              form.diseaseFamily.diabetes = false;
              form.diseaseFamily.metabolic = false;
              form.diseaseFamily.hypertension = false;
              form.diseaseFamily.cardiovascular = false;
              form.diseaseFamily.kidney = false;
              form.diseaseFamily.other = false;
            "
          >
            <div class="icon">
              <img
                src="@/assets/image/NewDesign/QuestionImage/diseaseIcon/noUnderlying.png"
              />
            </div>
            <div class="label">
              {{ $t("none") }}
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <!-- family cardiovascular -->
          <div
            id="buttonCardiovascularFamily"
            :class="`disease-long-card ${
              form.diseaseFamily.cardiovascular ? 'select' : ''
            }`"
            @click="
              form.diseaseFamily.cardiovascular =
                !form.diseaseFamily.cardiovascular;
              form.diseaseFamily.none = false;
            "
          >
            <div class="icon">
              <img
                src="@/assets/image/NewDesign/QuestionImage/diseaseIcon/cardiovascular.png"
              />
            </div>
            <div class="label">
              {{ $t("cvd") }}
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <!-- family other disease -->
          <div
            id="buttonOther"
            :class="`disease-long-card ${
              form.diseaseFamily.other ? 'select' : ''
            }`"
            @click="
              form.diseaseFamily.other = !form.diseaseFamily.other;
              form.diseaseFamily.none = false;
            "
          >
            <div class="icon">
              <img
                src="@/assets/image/NewDesign/QuestionImage/diseaseIcon/other.png"
              />
            </div>
            <div class="label">
              {{ $t("other") }}
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <!-- family kidney -->
          <div
            id="buttonKidneyFamily"
            :class="`disease-long-card ${
              form.diseaseFamily.kidney ? 'select' : ''
            }`"
            @click="
              form.diseaseFamily.kidney = !form.diseaseFamily.kidney;
              form.diseaseFamily.none = false;
            "
          >
            <div class="icon">
              <img
                src="@/assets/image/NewDesign/QuestionImage/diseaseIcon/kidney.png"
              />
            </div>
            <div class="label">
              {{ $t("kidney") }}
            </div>
            <div class="check-icon flex-mid">
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <!-- family other fill -->
          <div
            id="fillOtherData"
            v-if="form.diseaseFamily.other"
            :class="`disease-long-card select ${
              otherClickNextFamily ? 'error' : ''
            }`"
          >
            <div class="none-41 m-10 ml-0">
              <el-input
                v-model="form.diseaseFamily.otherData"
                :placeholder="$t('pleaseFillDisease')"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="footer-nav">
        <div class="footer-btn-next">
          <div
            id="next-6"
            @click="nextDiseaseFamily"
            style="width: 14rem"
            class="btn-48 btn-question btn mx-auto"
            :class="{
              disable: formValidate.question_disease_family,
              disable:
                !form.diseaseFamily.none &&
                !form.diseaseFamily.cancer &&
                !form.diseaseFamily.stroke &&
                !form.diseaseFamily.diabetes &&
                !form.diseaseFamily.metabolic &&
                !form.diseaseFamily.hypertension &&
                !form.diseaseFamily.cardiovascular &&
                !form.diseaseFamily.kidney &&
                !form.diseaseFamily.other,
            }"
          >
            {{ $t("next") }}
          </div>
        </div>
      </div>
    </div>
    <div
      v-else-if="step == 'question_exercise_week'"
      class="center exercise-week-container"
    >
      <div class="form-container body">
        <div
          :class="`question-title body-max-width ${
            lang == 'th' ? 'font-Prompt fs-38' : 'fs-22'
          }`"
        >
          {{ $t("exercise") }}
        </div>
        <div class="select-container">
          <!-- don't do exercise -->
          <div class="select-box">
            <div
              id="buttonNoExercise"
              @click="selectExercise('I don’t do exercise')"
              :class="`option-box flex-mid ${
                form.days_a_week_do_exercise == 'I don’t do exercise'
                  ? 'selected'
                  : ''
              }`"
            >
              <div class="text">{{ $t("dontdo") }}</div>
            </div>

            <div
              :class="`check-icon flex-mid ${
                form.days_a_week_do_exercise == 'I don’t do exercise'
                  ? 'select'
                  : ''
              }`"
            >
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <!-- less than 3 day -->
          <div class="select-box">
            <div
              id="buttonLessThan3Day"
              @click="selectExercise('<3 days/week')"
              :class="`option-box flex-mid ${
                form.days_a_week_do_exercise == '<3 days/week' ? 'selected' : ''
              }`"
            >
              <div class="text">{{ $t("lessThan3day") }}</div>
            </div>

            <div
              :class="`check-icon flex-mid ${
                form.days_a_week_do_exercise == '<3 days/week' ? 'select' : ''
              }`"
            >
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <!-- 3-5 days/week -->
          <div class="select-box">
            <div
              id="button3To5Day"
              @click="selectExercise('3-5 days/week')"
              :class="`option-box flex-mid ${
                form.days_a_week_do_exercise == '3-5 days/week'
                  ? 'selected'
                  : ''
              }`"
            >
              <div class="text">{{ $t("d3To5") }}</div>
            </div>

            <div
              :class="`check-icon flex-mid ${
                form.days_a_week_do_exercise == '3-5 days/week' ? 'select' : ''
              }`"
            >
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <!-- 6-7 days/week -->
          <div class="select-box">
            <div
              id="button6To7Day"
              @click="selectExercise('6-7 days/week')"
              :class="`option-box flex-mid ${
                form.days_a_week_do_exercise == '6-7 days/week'
                  ? 'selected'
                  : ''
              }`"
            >
              <div class="text">{{ $t("d6To7") }}</div>
            </div>

            <div
              :class="`check-icon flex-mid ${
                form.days_a_week_do_exercise == '6-7 days/week' ? 'select' : ''
              }`"
            >
              <svg
                width="19"
                height="15"
                viewBox="0 0 19 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.1786 2.35693L6.42856 13.107L1.82135 8.49979"
                  stroke="white"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>

          <!-- <div
            @click="form.days_a_week_do_exercise = ''"
            :class="`check-icon flex-mid ${
              form.days_a_week_do_exercise ? 'select' : ''
            }`"
          >
            <svg
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.42847 1.42871L6.57132 6.57157M6.57132 6.57157L11.7142 11.7144M6.57132 6.57157L11.7142 1.42871M6.57132 6.57157L1.42847 11.7144"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </div> -->
          <!-- <div
            :class="`option-box-mid absolute-mid flex-mid ${
              form.days_a_week_do_exercise ? 'select' : ''
            }`"
          >
            <p v-if="form.days_a_week_do_exercise == ''">{{ $t("select") }}</p>
          </div> -->
        </div>
        <div
          v-if="
            form.days_a_week_do_exercise != 'I don’t do exercise' &&
            form.days_a_week_do_exercise
          "
          class="center mt-20 mb-10"
        >
          <div class="fs-18 fw-500 center">
            {{ $t("exercisetime") }}
          </div>
          <div class="relative mt-16">
            <div class="absolute-mid focus-bg-exercise"></div>
            <div class="absolute-mid top-bottom-bg-exercise"></div>
            <swiper
              id="buttonSelectTimeExercise"
              :direction="'vertical'"
              :initial-slide="form.exercise"
              @slideChange="onSlideExercisePerTimeChange"
              :slides-per-view="3"
              :centeredSlides="true"
              :grabCursor="true"
              class="exercise-selected-exercise"
            >
              <!-- {{ form.exercise }} -->
              <swiper-slide
                v-for="value in exercisePerWeekOption"
                :id="value.value"
                :key="value.index"
              >
                <div
                  v-if="lang == 'th'"
                  class="flex-mid fc-DBDBDB fs-16 fw-500"
                  style="height: 4.8rem"
                >
                  {{ value.label_th }}
                </div>
                <div
                  v-else
                  class="flex-mid fc-DBDBDB fs-16 fw-500"
                  style="height: 4.8rem"
                >
                  {{ value.label_en }}
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
      <div class="footer-nav">
        <div class="footer-btn-next">
          <div
            @click="nextExerciseWeek"
            :class="{
              disable: formValidate.days_a_week_do_exercise,
              disable: !form.days_a_week_do_exercise,
            }"
            style="width: 14rem"
            class="btn-48 btn-question btn mx-auto"
          >
            {{ $t("next") }}
          </div>
        </div>
      </div>
    </div>
    <!-- <div v-else-if="step == 'question_sports'" class="center sports-container">
      <div class="form-container">
        <div class="body">
          <div
            :class="`question-title ${
              lang == 'th' ? 'font-DBAdmanX fs-38' : 'fs-22'
            }`"
          >
            {{ $t("sportsTrain") }}
          </div>
          <div class="flex-center pt-40">
            <div
              @click="form.sport = true"
              :class="`sports-btn flex-mid mt-22 ml-auto ${
                form.sport == true ? 'select' : ''
              }`"
            >
              <div class="label">
                <div class="mt-6">
                  <svg
                    width="38"
                    height="28"
                    viewBox="0 0 38 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M37.0624 1.18739C37.5012 1.62683 37.7477 2.22255 37.7477 2.84364C37.7477 3.46473 37.5012 4.06042 37.0624 4.49989L14.4062 27.1561C13.9667 27.5949 13.371 27.8415 12.7499 27.8415C12.1288 27.8415 11.5331 27.5949 11.0936 27.1561L0.937401 16.9999C0.523401 16.5556 0.298026 15.968 0.308713 15.3607C0.319432 14.7535 0.5654 14.1742 0.994838 13.7448C1.42424 13.3154 2.00359 13.0694 2.61078 13.0587C3.21796 13.048 3.80559 13.2734 4.2499 13.6874L12.7499 22.1874L33.7499 1.18739C34.1893 0.748484 34.7849 0.501953 35.4062 0.501953C36.0271 0.501953 36.623 0.748484 37.0624 1.18739Z"
                      fill="#6DB557"
                    />
                  </svg>
                </div>
                <div class="mt-8">{{ $t("yes") }}</div>
              </div>
            </div>
            <div
              @click="form.sport = false"
              :class="`sports-btn flex-mid mt-22 ml-auto ${
                form.sport == false ? 'select' : ''
              }`"
            >
              <div class="label">
                <div class="mt-6">
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M1.62489 1.62487C2.06433 1.18596 2.66005 0.939428 3.28114 0.939428C3.90223 0.939428 4.49792 1.18596 4.93739 1.62487L14.9999 11.6874L25.0624 1.62487C25.2771 1.39458 25.5358 1.2099 25.8233 1.0818C26.1108 0.95371 26.4211 0.884835 26.7358 0.879272C27.0505 0.87371 27.363 0.931616 27.6549 1.04949C27.9468 1.16737 28.2118 1.3428 28.4343 1.56537C28.6571 1.78793 28.8324 2.05305 28.9502 2.34487C29.068 2.63671 29.1261 2.9493 29.1205 3.26399C29.1149 3.57871 29.0461 3.88905 28.918 4.17655C28.7899 4.46405 28.6052 4.7228 28.3749 4.93737L18.3124 14.9999L28.3749 25.0624C28.6052 25.2771 28.7899 25.5358 28.918 25.8233C29.0461 26.1108 29.1149 26.4211 29.1205 26.7358C29.1261 27.0505 29.068 27.363 28.9502 27.6549C28.8324 27.9467 28.6571 28.2117 28.4343 28.4342C28.2118 28.6571 27.9468 28.8324 27.6549 28.9502C27.363 29.068 27.0505 29.1261 26.7358 29.1205C26.4211 29.1149 26.1108 29.0461 25.8233 28.918C25.5358 28.7899 25.2771 28.6052 25.0624 28.3749L14.9999 18.3124L4.93739 28.3749C4.49308 28.7889 3.90542 29.0142 3.29823 29.0036C2.69105 28.9927 2.11173 28.7467 1.6823 28.3174C1.25289 27.888 1.00692 27.3086 0.996203 26.7014C0.985485 26.0942 1.21089 25.5067 1.62489 25.0624L11.6874 14.9999L1.62489 4.93737C1.18598 4.49793 0.939453 3.90221 0.939453 3.28112C0.939453 2.66002 1.18598 2.06433 1.62489 1.62487Z"
                      fill="#6DB557"
                    />
                  </svg>
                </div>
                <div class="mt-8">{{ $t("no") }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-btn-next">
        <div
          @click="nextSport"
          :class="{
            disable: formValidate.sport,
          }"
          style="width: 14rem"
          class="btn-48 btn-primary btn mx-auto"
        >
          {{ $t("next") }}
        </div>
      </div>
    </div> -->
    <!-- <div v-else-if="step == 'question_finish'" class="center finish-container">
      <div class="form-container">
        <div class="body flex-mid">
          <div class="center">
            <img
              src="@/assets/image/Question/finish.gif"
              alt=""
              class="mx-auto"
              style="
                width: 100%;
                max-width: 19rem;
                height: 100%;
                object-fit: scale-down;
              "
            />
            <div class="fs-24 fc-545454">Finish!</div>

          </div>
        </div>
      </div>
    </div> -->
  </div>

  <!-- <div v-if="step == 'Sync_data_dialog'" class="footer">
    <div class="bottom-screen">
      <div class="mx-auto footer-modal">
        <div class="flex-center">
          <div
            class="ml-auto cursor-pointer"
            @click="(step = 'let_start'), (shadowScreen = false)"
          >
            <svg
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.413479 0.449024C0.678563 0.184828 1.03792 0.0364306 1.41259 0.0364306C1.78725 0.0364306 2.14659 0.184828 2.41169 0.449024L8.48173 6.50606L14.5518 0.449024C14.6813 0.310408 14.8374 0.199237 15.0108 0.122132C15.1842 0.0450273 15.3714 0.00356856 15.5612 0.000220264C15.7511 -0.00312803 15.9396 0.0317282 16.1157 0.102682C16.2917 0.173636 16.4516 0.279239 16.5858 0.413208C16.7202 0.547178 16.826 0.706768 16.897 0.882422C16.9681 1.05809 17.0032 1.24626 16.9998 1.43568C16.9964 1.62512 16.9549 1.81193 16.8776 1.98499C16.8003 2.15805 16.6889 2.3138 16.55 2.44295L10.4799 8.49999L16.55 14.557C16.6889 14.6863 16.8003 14.842 16.8776 15.0151C16.9549 15.1881 16.9964 15.3749 16.9998 15.5643C17.0032 15.7538 16.9681 15.9419 16.897 16.1176C16.826 16.2932 16.7202 16.4528 16.5858 16.5867C16.4516 16.7208 16.2917 16.8263 16.1157 16.8973C15.9396 16.9682 15.7511 17.0032 15.5612 16.9998C15.3714 16.9964 15.1842 16.955 15.0108 16.8779C14.8374 16.8008 14.6813 16.6896 14.5518 16.551L8.48173 10.4939L2.41169 16.551C2.14367 16.8002 1.78917 16.9358 1.4229 16.9294C1.05662 16.9228 0.70716 16.7748 0.448109 16.5163C0.189076 16.2579 0.0406996 15.9091 0.0342337 15.5436C0.0277678 15.1782 0.163741 14.8245 0.413479 14.557L6.48352 8.49999L0.413479 2.44295C0.148716 2.17844 0 1.81985 0 1.44599C0 1.07213 0.148716 0.713558 0.413479 0.449024Z"
                fill="#B0B0B0"
              />
            </svg>
          </div>
        </div>
        <div class="fs-18 fw-500">{{ $t("syncData") }}</div>
        <div class="flex-mid mt-20">
          <div
            @click="getSyncData()"
            style="width: 14rem"
            class="btn-48 btn-primary btn mx-auto mr-10"
          >
            {{ $t("yesSync") }}
          </div>
          <div
            @click="skipSyncData()"
            style="width: 14rem"
            class="btn-48 btn-second btn mr-auto ml-10"
          >
            {{ $t("noSync") }}
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <!-- <div class="remove-padding-dialog">
    <el-dialog v-model="getDataDialog" width="35.5rem">
      <div class="center p-28">
        <div class="mt-40 fc-000000 fs-16">
          ผลจากสมิติเวช ณ วันที่ {{ dataSync.data }}
        </div>
        <div class="flex-mid mt-40">
          <div
            @click="useDataDialog()"
            style="width: 14rem"
            class="btn-48 btn-question btn mx-auto mr-10"
          >
            Yes
          </div>
          <div
            @click="skipSyncData()"
            style="width: 14rem"
            class="btn-48 btn-second btn mr-auto ml-10"
          >
            No
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog v-model="dataNotFoundDialog" width="35.5rem">
      <div class="center p-28">
        <div class="mt-40 fc-000000 fs-16">ไม่พบข้อมูล</div>
        <div class="flex-mid mt-40">
          <div
            @click="startQuestion()"
            style="width: 14rem"
            class="btn-48 btn-question btn"
          >
            Yes
          </div>
        </div>
      </div>
    </el-dialog>
  </div> -->
</template>

<script>
import { defineComponent } from "vue";
// import { Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue";
import { Mousewheel } from "swiper";
import axios from "axios";
import * as config from "@/assets/js/config.js";
var AmazonCognitoIdentity = require("amazon-cognito-identity-js");
import "swiper/swiper.min.css";
import "swiper/modules/autoplay/autoplay.scss";
import "swiper/modules/navigation/navigation.scss"; // Navigation module
import "swiper/modules/pagination/pagination.scss"; // Pagination module

export default defineComponent({
  name: "Question",
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      modules: [Mousewheel],
    };
  },
  data() {
    return {
      step: "let_start", // let_start
      shadowScreen: false,
      getDataDialog: false,
      dataNotFoundDialog: false,
      accessToken: null,
      otherClickNext: false,
      lang: "th",
      isLeapYear: false,
      options: {
        month: [
          "january",
          "february",
          "march",
          "april",
          "may",
          "june",
          "july",
          "august",
          "september",
          "october",
          "november",
          "december",
        ],
        career: [
          "ผู้บริหาร",
          "ธุรกิจส่วนตัว",
          "พนักงานรัฐ",
          "พนักงานบริษัท",
          "นักกีฬา",
          "ว่างงาน",
          "นักเรียน/นักศึกษา",
          "อื่นๆ",
        ],
      },
      exercisePerWeekOption: [
        {
          label_th: "น้อยกว่า 15 นาที",
          label_en: "Less than 15 minutes",
          id: "less than 15 minutes per day",
          index: 0,
        },
        {
          label_th: "15 - 30 นาที",
          label_en: "15-30 minutes",
          id: "15-30 minutes per day",
          index: 1,
        },
        {
          label_th: "30 - 60 นาที",
          label_en: "30-60 minutes",
          id: "30-60 minutes per day",
          index: 2,
        },
        {
          label_th: "มากกว่า 60 นาที",
          label_en: "More than 60 minutes",
          id: "more than 1 hour",
          index: 4,
        },
      ],
      dataSync: {
        data: "",
      },
      form: {
        ssid: "",
        sex: "M",
        birthDate: "2000-01-01",
        dayOfBirth: "1",
        monthOfBirth: "1",
        yearOfBirth: "2000",
        career: "",
        careerInput: "",
        height: "",
        weight: "",
        BMI: "",
        waistline: "",
        bloodPressureHigher: "",
        bloodPressureLower: "",
        cholesterol: "",
        cholesterolLDL: "",
        bloodSugar: "",
        HbA1c: "",

        behavior: {
          snoring: false,
          alcohol: false,
          exercise: false,
          healthCheck: false,
          nothealthCheck: false,
          smoking: false,
          airPollution: false,
        },
        disease: {
          none: false,
          cancer: false,
          diabetes: false,
          hypertension: false,
          cardiovascular: false,
          kidney: false,
          stroke: false,
          metabolic: false,
          other: false,
          otherData: "",
        },
        diseaseFamily: {
          cancer: false,
          diabetes: false,
          hypertension: false,
          cardiovascular: false,
          kidney: false,
          stroke: false,
          metabolic: false,
          other: false,
          otherData: "",
        },
        days_a_week_do_exercise: "",
        exercise: 0,
        activity: "",
        sport: null,
      },
      formValidate: {
        career: false,
        careerInput: false,
        height: false,
        weight: false,
        waistline: false,
        activity: false,
        days_a_week_do_exercise: false,
        exercise: false,
        sport: false,
        dayOfBirth: false,
        monthOfBirth: false,
        yearOfBirth: false,
        sbp: false,
        dbp: false,
        cholesterol: false,
        cholesterolLDL: false,
        bloodSugar: false,
        HbA1c: false,
        question_disease: false,
        question_disease_family: false,
      },
      exercisePerTime: [
        "less than 15 minutes per day",
        "15-30 minutes per day",
        "30-60 minutes per day",
        "more than 1 hour",
      ],
      username: "",
      memberId: "",
    };
  },
  mounted() {
    this.accessToken = this.$cookies.get("access_token");
    this.lang = this.$cookies.get("lang");
    this.memberId = this.$cookies.get("memberId");
    this.username = this.$cookies.get("username");
    this.getData();
    this.getOldData();
  },
  computed: {
    bmi() {
      if (
        !this.form.weight ||
        !this.form.height ||
        this.formValidate.height ||
        this.formValidate.weight
      ) {
        return 0;
      }
      return (this.form.weight / Math.pow(this.form.height / 100.0, 2)).toFixed(
        2
      );
    },
  },
  methods: {
    onSlideExercisePerTimeChange(value) {
      console.log(this.exercisePerWeekOption[value.activeIndex]);
      // console.log(this.exercisePerWeekOption[value.activeIndex].id);

      // console.log(this.exercisePerWeekOption[value.slides[value.activeIndex].id])
      // this.form.exercise = this.exercisePerWeekOption[value.slides[value.activeIndex].id];
      console.log(value.activeIndex, typeof value.activeIndex);
      this.form.exercise = value.activeIndex;
    },
    onSlideDayChange(value) {
      this.form.dayOfBirth = value.slides[value.activeIndex].id;
    },
    onSlideMonthChange(value) {
      this.form.monthOfBirth = value.activeIndex + 1;
      // this.form.monthOfBirth = value.slides[value.activeIndex+1].id;
    },
    onSlideYearChange(value) {
      this.form.yearOfBirth = value.slides[value.activeIndex].id;
      this.checkLeapYear(value.slides[value.activeIndex].id);
    },
    checkDayOfBirthValidate() {
      this.formValidate.dayOfBirth = true;
      if (this.form.dayOfBirth) {
        this.formValidate.dayOfBirth = false;
      }
    },
    checkMonthOfBirthValidate() {
      this.formValidate.monthOfBirth = true;
      if (this.form.monthOfBirth) {
        this.formValidate.monthOfBirth = false;
      }
    },
    checkYearOfBirthValidate() {
      this.formValidate.yearOfBirth = true;
      if (this.form.yearOfBirth) {
        this.formValidate.yearOfBirth = false;
      }
    },
    checkLeapYear(value) {
      // console.log(value)
      if (value % 4 == 0) {
        if (value % 100 == 0) {
          if (value % 400 == 0) {
            this.isLeapYear = true;
          } else {
            this.isLeapYear = false;
          }
        } else {
          this.isLeapYear = true;
        }
      } else {
        this.isLeapYear = false;
      }
      // console.log("check leap year",this.isLeapYear)
    },
    nextDateOfBirthl() {
      this.checkDayOfBirthValidate();
      this.checkMonthOfBirthValidate();
      this.checkYearOfBirthValidate();
      setTimeout(() => {
        if (
          !this.formValidate.dayOfBirth &&
          !this.formValidate.monthOfBirth &&
          !this.formValidate.yearOfBirth
        ) {
          // this.step = "question_career";
          this.step = "question_body_details";
          this.form.birthDate =
            this.form.yearOfBirth +
            "-" +
            ("0" + this.form.monthOfBirth).slice(-2) +
            "-" +
            ("0" + this.form.dayOfBirth).slice(-2);
          this.updateCustomer();
        }
      }, 400);
    },
    checkBloodPressureHeight() {
      // this.form.bloodPressureHigher
      let bloodHigher = this.form.bloodPressureHigher;
      if (bloodHigher.length > 3) {
        bloodHigher = bloodHigher.slice(0, 3);
        this.form.bloodPressureHigher = bloodHigher;
      }
      console.log(this.form.bloodPressureHigher);
    },
    checkBloodPressureLow() {
      let bloodLower = this.form.bloodPressureLower;
      if (bloodLower.length > 3) {
        bloodLower = bloodLower.slice(0, 3);
        this.form.bloodPressureLower = bloodLower;
      }
      console.log(this.form.bloodPressureHigher);
    },
    checkCholesterol() {
      let cholesterolLDL = this.form.cholesterolLDL;
      if (cholesterolLDL.length > 6) {
        cholesterolLDL = cholesterolLDL.slice(0, 6);
        this.form.cholesterolLDL = cholesterolLDL;
      }
      if (this.form.cholesterolLDL) {
        this.formValidate.cholesterolLDL = false;
      }
    },
    checkBloodGlucose() {
      // this.form.bloodPressureHigher
      let bloodSugar = this.form.bloodSugar;
      if (bloodSugar.length > 6) {
        bloodSugar = bloodSugar.slice(0, 6);
        this.form.bloodSugar = bloodSugar;
      }
      if (this.form.bloodSugar) {
        this.formValidate.bloodSugar = false;
      }
    },
    checkHbA1c() {
      let HbA1c = this.form.HbA1c;
      if (HbA1c.length > 6) {
        HbA1c = HbA1c.slice(0, 6);
        this.form.HbA1c = HbA1c;
      }
      if (this.form.HbA1c) {
        this.formValidate.HbA1c = false;
      }
    },
    nextCareerForm() {
      this.checkCareerValidate();
      if (!this.formValidate.career && !this.formValidate.careerInput) {
        this.step = "question_body_details";
      }
    },
    checkHeightValidate() {
      this.formValidate.height = true;
      let height = this.form.height;
      parseInt(height.toString().replace(/\./, ""));
      if (height.length > 3) {
        height = height.slice(0, 2);
        this.form.height = height + 0;
      }
      if (this.form.height) {
        let heightInt = parseInt(this.form.height);
        if (heightInt >= 120) {
          this.formValidate.height = false;
        }
      }
    },
    checkWeightValidate() {
      let weight = this.form.weight;
      this.formValidate.weight = true;

      console.log(typeof weight);
      if (weight.length > 3) {
        weight = weight.slice(0, 2);
        this.form.weight = weight + 0;
      }
      if (this.form.weight) {
        let weightInt = parseInt(this.form.weight);
        if (weightInt >= 35) {
          this.formValidate.weight = false;
        }
      }
    },
    checkWaistlineValidate() {
      this.formValidate.waistline = true;
      let waistline = this.form.waistline;
      if (waistline.length > 3) {
        this.form.waistline = this.form.waistline.slice(0, 2);
      }
      if (this.form.waistline) {
        let waistlineInt = parseInt(this.form.waistline);
        if (waistlineInt >= 15) {
          this.formValidate.waistline = false;
        }
      }
    },
    nextBodyDetail() {
      this.checkHeightValidate();
      this.checkWeightValidate();
      this.checkWaistlineValidate();
      setTimeout(() => {
        if (
          !this.formValidate.height &&
          !this.formValidate.weight &&
          !this.formValidate.waistline
        ) {
          // this.sendForm(1, this.form.height);
          // this.sendForm(2, this.form.weight);
          // this.sendForm(3, this.bmi);
          // this.sendForm(4, this.form.waistline);
          this.step = "question_health";
        }
      }, 400);
    },
    nextHealthDetail() {
      // if (this.form.bloodPressureHigher) {
      //   this.sendForm(5, this.form.bloodPressureHigher);
      // }
      // if (this.form.bloodPressureLower) {
      //   this.sendForm(6, this.form.bloodPressureLower);
      // }
      // if (this.form.cholesterolLDL) {
      //   this.sendForm(28, this.form.cholesterolLDL);
      // }
      // if (this.form.bloodSugar) {
      //   this.sendForm(8, this.form.bloodSugar);
      // }
      // if (this.form.HbA1c) {
      //   this.sendForm(26, this.form.HbA1c);
      // }
      this.step = "question_behavior";
    },
    nextBehavior() {
      // this.sendForm(22, this.form.behavior.healthCheck);
      // this.sendForm(65, this.form.behavior.nothealthCheck);
      // this.sendForm(10, this.form.behavior.alcohol);
      // this.sendForm(11, this.form.behavior.smoking);
      // this.sendForm(13, this.form.behavior.snoring);
      // this.sendForm(71, this.form.behavior.airPollution);
      this.step = "question_disease";
    },
    checkActivityValidate() {
      this.formValidate.activity = true;
      if (this.form.activity) {
        this.formValidate.activity = false;
      }
    },
    nextActivity() {
      this.checkActivityValidate();
      if (!this.formValidate.activity) {
        // this.sendForm(48, this.form.activity);
        this.step = "question_exercise_week";
      }
    },
    checkDisease() {
      // this.formValidate.question_disease_family = true;
      if (
        (this.form.disease.cancer == false &&
          this.form.disease.diabetes == false &&
          this.form.disease.hypertension == false &&
          this.form.disease.cardiovascular == false &&
          this.form.disease.kidney == false &&
          this.form.disease.stroke == false &&
          this.form.disease.metabolic == false &&
          this.form.disease.none == false) ||
        this.form.disease.other == false
      ) {
        // this.form.disease.none = true;
        // this.otherClickNext = true;
        this.formValidate.question_disease = true;
      } else {
        if (this.form.disease.other != false) {
          if (this.form.disease.otherData) {
            this.otherClickNext = true;
            this.formValidate.question_disease = true;
          } else {
            this.otherClickNext = false;
          }
        } else {
          this.otherClickNext = true;
          this.formValidate.question_disease = false;
        }
      }
    },
    nextDisease() {
      if (
        this.form.disease.cancer ||
        this.form.disease.diabetes ||
        this.form.disease.hypertension ||
        this.form.disease.cardiovascular ||
        this.form.disease.kidney ||
        this.form.disease.stroke ||
        this.form.disease.metabolic ||
        this.form.disease.none ||
        this.form.disease.other
      ) {
        if (this.form.disease.other) {
          if (this.form.disease.otherData) {
            this.otherClickNext = false;
            this.step = "question_disease_family";
          } else {
            this.otherClickNext = true;
            this.formValidate.question_disease = true;
          }
        } else {
          this.step = "question_disease_family";
        }
      }

      // // console.log("this.formValidate.question_disease",this.formValidate.question_disease)
      // // if (!this.formValidate.question_disease) {
      // //   console.log("here",this.formValidate.question_disease)
      // //   // this.sendForm(14, this.form.disease.diabetes);
      // //   // this.sendForm(16, this.form.disease.hypertension);
      // //   // this.sendForm(18, this.form.disease.cardiovascular);
      // //   // this.sendForm(20, this.form.disease.cancer);
      // //   // this.sendForm(42, this.form.disease.kidney);
      // //   // this.sendForm(47, this.form.disease.otherData);
      // //   // this.sendForm(66, this.form.disease.stroke);
      // //   // this.sendForm(67, this.form.disease.metabolic);
      // //   // this.sendForm(49, this.form.disease.none);

      // //   this.step = "question_disease_family";
      // //   this.otherClickNext = false;
      // // }
      // console.log("step",this.step)
    },
    nextDiseaseFamily() {
      // this.sendForm(15, this.form.diseaseFamily.diabetes);
      // this.sendForm(17, this.form.diseaseFamily.hypertension);
      // this.sendForm(19, this.form.diseaseFamily.cardiovascular);
      // this.sendForm(21, this.form.diseaseFamily.cancer);
      // this.sendForm(43, this.form.diseaseFamily.kidney);
      // this.sendForm(68, this.form.diseaseFamily.stroke);
      // this.sendForm(69, this.form.diseaseFamily.metabolic);
      // this.step = "question_activity";

      if (
        this.form.diseaseFamily.cancer ||
        this.form.diseaseFamily.diabetes ||
        this.form.diseaseFamily.hypertension ||
        this.form.diseaseFamily.cardiovascular ||
        this.form.diseaseFamily.kidney ||
        this.form.diseaseFamily.stroke ||
        this.form.diseaseFamily.metabolic ||
        this.form.diseaseFamily.none ||
        this.form.diseaseFamily.other
      ) {
        if (this.form.diseaseFamily.other) {
          if (this.form.diseaseFamily.otherData) {
            this.otherClickNextFamily = false;
            this.step = "question_exercise_week";
            this.formValidate.question_disease_family = false;
          } else {
            this.otherClickNextFamily = true;
            this.formValidate.question_disease_family = true;
          }
        } else {
          this.step = "question_exercise_week";
          this.formValidate.question_disease_family = false;
        }
      }
    },
    checkExerciseWeek() {
      this.formValidate.days_a_week_do_exercise = true;
      if (this.form.days_a_week_do_exercise) {
        this.formValidate.days_a_week_do_exercise = false;
      }
    },
    nextExerciseWeek() {
      this.checkExerciseWeek();
      // setTimeout(() => {
      if (!this.formValidate.days_a_week_do_exercise) {
        // this.sendForm(40, this.form.days_a_week_do_exercise);
        if (this.form.days_a_week_do_exercise == "I don’t do exercise") {
          // this.step = "question_sports";
          // this.step = "question_finish";
          this.submitForm();
        } else {
          console.log(this.form.exercise);
          // this.sendForm(41, this.exercisePerTime[this.form.exercise]);
          // this.step = "question_finish";
          this.submitForm();
          // this.step = "question_sports";
        }
      }
      // }, 400);
    },
    checkExerciseTime() {
      this.formValidate.exercise = true;
      if (this.form.exercise) {
        this.formValidate.exercise = false;
      }
    },
    nextExerciseTime() {
      this.checkExerciseTime();
      // setTimeout(() => {
      if (!this.formValidate.exercise) {
        console.log(this.exercisePerTime[this.form.exercise]);
        // this.sendForm(41, this.exercisePerTime[this.form.exercise]);
        // this.sendForm(40, this.exercisePerWeekId[this.form.exercisePerWeek]);
        // this.step = "question_sports";
        this.step = "question_finish";
      }
      // }, 400);
    },
    checkSport() {
      this.formValidate.sport = true;
      if (this.form.sport) {
        this.formValidate.sport = false;
      }
    },
    nextSport() {
      this.checkSport();
      // setTimeout(() => {
      if (!this.form.sport) {
        // this.sendForm(46, this.form.sport);
        this.submitForm();
      }
      // }, 400);
    },
    submitForm() {
      // this.step = "question_finish";

      let reqBody = [
        {
          questionId: 1,
          answer: this.form.height,
        },
        {
          questionId: 2,
          answer: this.form.weight,
        },
        {
          questionId: 3,
          answer: this.bmi,
        },
        {
          questionId: 4,
          answer: this.form.waistline,
        },
        {
          questionId: 5,
          answer: this.form.bloodPressureHigher,
        },
        {
          questionId: 6,
          answer: this.form.bloodPressureLower,
        },
        {
          questionId: 8,
          answer: this.form.bloodSugar,
        },
        {
          questionId: 22,
          answer: this.form.behavior.healthCheck,
        },
        {
          questionId: 65,
          answer: this.form.behavior.nothealthCheck,
        },
        {
          questionId: 10,
          answer: this.form.behavior.alcohol,
        },
        {
          questionId: 11,
          answer: this.form.behavior.smoking,
        },
        {
          questionId: 13,
          answer: this.form.behavior.snoring,
        },
        {
          questionId: 14,
          answer: this.form.disease.diabetes,
        },
        {
          questionId: 16,
          answer: this.form.disease.hypertension,
        },
        {
          questionId: 18,
          answer: this.form.disease.cardiovascular,
        },
        {
          questionId: 20,
          answer: this.form.disease.cancer,
        },
        {
          questionId: 42,
          answer: this.form.disease.kidney,
        },
        {
          questionId: 47,
          answer: this.form.disease.otherData,
        },
        {
          questionId: 66,
          answer: this.form.disease.stroke,
        },
        {
          questionId: 67,
          answer: this.form.disease.metabolic,
        },
        {
          questionId: 49,
          answer: this.form.disease.none,
        },
        {
          questionId: 15,
          answer: this.form.diseaseFamily.diabetes,
        },
        {
          questionId: 17,
          answer: this.form.diseaseFamily.hypertension,
        },
        {
          questionId: 19,
          answer: this.form.diseaseFamily.cardiovascular,
        },
        {
          questionId: 21,
          answer: this.form.diseaseFamily.cancer,
        },
        {
          questionId: 43,
          answer: this.form.diseaseFamily.kidney,
        },

        {
          questionId: 40,
          answer: this.form.days_a_week_do_exercise,
        },
        {
          questionId: 41,
          answer: this.exercisePerTime[this.form.exercise],
        },
        {
          questionId: 28,
          answer: this.form.cholesterolLDL,
        },
        {
          questionId: 26,
          answer: this.form.HbA1c,
        },
        {
          questionId: 71,
          answer: this.form.behavior.airPollution,
        },
        {
          questionId: 68,
          answer: this.form.diseaseFamily.stroke,
        },
        {
          questionId: 69,
          answer: this.form.diseaseFamily.metabolic,
        },
        {
          questionId: 72,
          answer: this.form.diseaseFamily.none,
        },
      ];

      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/health-assessment/inserts",
          {
            createHealthAssessmentReqBeans: reqBody,
          },
          {
            headers: {
              "Accept-Language": this.lang,
              Authorization: "Bearer " + this.accessToken,
            },
          }
        )
        .then((res) => {
          console.log(res.data);
          this.$gtag.config({
            user_id: this.username,
          });
          this.$gtag.event("click_submitquestionaire_button", {
            event_category: "Questionaire_page",
            event_label: "click submit questionaire button",
          });
          this.$router.push("/assessment-report");
        })
        .catch((error) => {
          console.log(error);
          this.loadingStatus = false;
          if (error.response.status == 403) {
            this.getNewToken();
            console.log("getNewToken");
          } else {
            this.error = error;
            console.log(error);
          }
        });
    },
    letStart() {
      // if(!this.form.ssid){
      //   this.shadowScreen = true;
      //   this.step = "Sync_data_dialog";
      //   this.dataSync = {
      //     data: "02 / 03/ 2022",
      //   };
      // }else{
      if (this.form.ssid || this.form.ssid == "xx") {
        this.step = "question_body_details";
      } else {
        this.step = "question_sex";
      }
      this.shadowScreen = false;
      this.getDataDialog = false;
      this.dataNotFoundDialog = false;
      this.$gtag.config({
        user_id: this.username,
      });
      this.$gtag.event("click_startquestionaire_button", {
        event_category: "Questionaire_page",
        event_label: "click start questionaire button",
      });

      // }
    },
    getSyncData() {
      this.shadowScreen = false;
      this.step = "let_start";
      this.getDataDialog = true;
    },
    skipSyncData() {
      this.shadowScreen = false;
      this.step = "question_sex";
      this.getDataDialog = false;
      this.dataNotFoundDialog = false;
    },
    useDataDialog() {
      this.getDataDialog = false;
      this.dataNotFoundDialog = true;
    },
    startQuestion() {
      this.dataNotFoundDialog = false;
      this.step = "question_sex";
    },
    switchSex() {
      if (this.form.sex == "M") {
        this.form.sex = "F";
      } else {
        this.form.sex = "M";
      }
    },
    selectExercise(value) {
      if (value == this.form.days_a_week_do_exercise) {
        this.form.days_a_week_do_exercise = "";
      } else {
        this.form.days_a_week_do_exercise = value;
      }
      this.checkExerciseWeek();
    },
    getArrForYears() {
      const date = new Date();
      const year = date.getFullYear();
      const arr = [];
      for (let i = year - 110; i < year - 18; i++) {
        arr.unshift(i);
      }
      return arr;
    },
    backBTN() {
      // --- value of page ---
      // let_start
      // Sync_data_dialog
      // question_sex
      // question_career
      // question_body_details
      // question_health
      // question_behavior
      // question_disease
      // question_disease_family
      // question_activity
      // question_exercise_week
      // question_sports
      // question_finish
      let step = this.step;
      if (step == "question_sex") {
        step = "let_start";
      } else if (
        step == "question_body_details" &&
        this.form.ssid != "xx" &&
        this.form.ssid != ""
      ) {
        step = "let_start";
      } else if (step == "question_body_details") {
        step = "question_sex";
      } else if (step == "question_health") {
        step = "question_body_details";
      } else if (step == "question_behavior") {
        step = "question_health";
      } else if (step == "question_disease") {
        step = "question_behavior";
      } else if (step == "question_disease_family") {
        step = "question_disease";
      } else if (step == "question_exercise_week") {
        step = "question_disease_family";
      }
      return step;
    },
    returnMockArray(value) {
      let arr = [];
      for (let i = 0; i < value; i++) {
        arr.push("mock_step" + i);
      }
      return arr;
    },
    showStepValue() {
      let step = "";
      switch (this.step) {
        case "question_sex":
          step = 1;
          break;
        case "question_body_details":
          step = 2;
          break;
        case "question_health":
          step = 3;
          break;
        case "question_behavior":
          step = 4;
          break;
        case "question_disease":
          step = 5;
          break;
        case "question_disease_family":
          step = 6;
          break;
        case "question_exercise_week":
          step = 7;
          break;
      }
      return step;
    },
    showBackBTN() {
      const stepArray = [
        "question_sex",
        "question_body_details",
        "question_health",
        "question_behavior",
        "question_disease",
        "question_disease_family",
        "question_exercise_week",
      ];
      const arrayLength = stepArray.length;
      for (let i = 0; i < arrayLength; i++) {
        if (this.step == stepArray[i]) {
          return true;
        }
      }
      return false;
    },
    getData() {
      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/customer/min/get",
          {},
          {
            headers: {
              "Accept-Language": this.lang,
              Authorization: "Bearer " + this.accessToken,
            },
          }
        )
        .then((response) => {
          let res = response.data;
          if (res.customer.gender != null) {
            this.form.sex = res.customer.gender;
          }
          this.form.birthDate = res.customer.birthDate;
          this.form.ssid = res.customer.ssid;
          console.log("form.ssid", this.form.ssid);
          if (this.form.birthDate) {
            const birthDate = this.form.birthDate.split("-");
            this.form.yearOfBirth = birthDate[0];
            this.form.monthOfBirth = birthDate[1];
            this.form.dayOfBirth = birthDate[2];
          }
        })
        .catch((error) => {
          console.log(error);
          this.loadingStatus = false;
          if (error.response.status == 403) {
            this.getNewToken();
            console.log("getNewToken");
          } else {
            this.error = error;
            console.log(error);
          }
        });
    },
    getOldData() {
      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/datacenter/get",
          {
            questionnaireId: 1,
          },
          {
            headers: {
              "Accept-Language": this.lang,
              Authorization: "Bearer " + this.accessToken,
            },
          }
        )
        .then((res) => {
          console.log(
            "res.data.questionInformations",
            res.data.questionInformations
          );
          let returnData = res.data.questionInformations;
          for (let i = 0; i < returnData.length; i++) {
            // console.log(returnData[i].questionId)
            switch (returnData[i].questionId) {
              case 1:
                this.form.height = Number(returnData[i].answer);
                break;
              case 2:
                this.form.weight = Number(returnData[i].answer);
                break;
              case 4:
                this.form.waistline = Number(returnData[i].answer);
                break;
              case 5:
                this.form.bloodPressureHigher = Number(returnData[i].answer);
                break;
              case 6:
                this.form.bloodPressureLower = Number(returnData[i].answer);
                break;
              // case 7:
              //   this.form.cholesterol = Number(returnData[i].answer);
              //   break;
              case 8:
                this.form.bloodSugar = Number(returnData[i].answer);
                break;
              case 9:
                if (this.options.career.includes(returnData[i].answer)) {
                  this.form.career = returnData[i].answer;
                } else {
                  this.form.career = "อื่นๆ";
                  this.form.careerInput = returnData[i].answer;
                }
                break;
              case 10:
                this.form.behavior.alcohol = returnData[i].answer === "true";
                break;
              case 11:
                this.form.behavior.smoking = returnData[i].answer === "true";
                break;
              case 13:
                this.form.behavior.snoring = returnData[i].answer === "true";
                break;
              case 14:
                this.form.disease.diabetes = returnData[i].answer === "true";
                break;
              case 15:
                this.form.diseaseFamily.diabetes =
                  returnData[i].answer === "true";
                break;
              case 16:
                this.form.disease.hypertension =
                  returnData[i].answer === "true";
                break;
              case 17:
                this.form.diseaseFamily.hypertension =
                  returnData[i].answer === "true";
                break;
              case 18:
                this.form.disease.cardiovascular =
                  returnData[i].answer === "true";
                break;
              case 19:
                this.form.diseaseFamily.cardiovascular =
                  returnData[i].answer === "true";
                break;
              case 20:
                this.form.disease.cancer = returnData[i].answer === "true";
                break;
              case 21:
                this.form.diseaseFamily.cancer =
                  returnData[i].answer === "true";
                break;
              case 22:
                this.form.behavior.healthCheck =
                  returnData[i].answer === "true";
                break;
              case 26:
                this.form.HbA1c = Number(returnData[i].answer);
                break;
              case 28:
                this.form.cholesterolLDL = Number(returnData[i].answer);
                break;
              case 40:
                this.form.days_a_week_do_exercise = returnData[i].answer;
                break;
              case 41:
                this.form.exercise = this.exercisePerTime.indexOf(
                  returnData[i].answer
                );
                break;
              case 42:
                this.form.disease.kidney = returnData[i].answer === "true";
                break;
              case 43:
                this.form.diseaseFamily.kidney =
                  returnData[i].answer === "true";
                break;
              case 46:
                this.form.sport = returnData[i].answer;
                break;
              case 47:
                this.form.disease.otherData = returnData[i].answer;
                if (this.form.disease.otherData) {
                  this.form.disease.other = true;
                }
                break;
              case 48:
                this.form.activity = returnData[i].answer;
                break;
              case 49:
                this.form.disease.none = returnData[i].answer === "true";
                break;
              case 65:
                this.form.behavior.nothealthCheck =
                  returnData[i].answer === "true";
                break;
              case 66:
                this.form.disease.stroke = returnData[i].answer === "true";
                break;
              case 67:
                this.form.disease.metabolic = returnData[i].answer === "true";
                break;
              case 68:
                this.form.diseaseFamily.stroke =
                  returnData[i].answer === "true";
                break;
              case 69:
                this.form.diseaseFamily.metabolic =
                  returnData[i].answer === "true";
                break;
              case 71:
                this.form.behavior.airPollution =
                  returnData[i].answer === "true";
                break;
              case 72:
                this.form.diseaseFamily.none = returnData[i].answer === "true";
                break;
            }
          }
          if (
            this.form.disease.cancer == true ||
            this.form.disease.diabetes == true ||
            this.form.disease.hypertension == true ||
            this.form.disease.cardiovascular == true ||
            this.form.disease.kidney == true ||
            this.form.disease.stroke == true ||
            this.form.disease.metabolic == true
          ) {
            this.form.disease.none = false;
          }
        });
    },
    sendForm(questionId, answer) {
      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/health-assessment/update",
          {
            updateHealthAssessmentReqBean: {
              questionId: questionId,
              answer: answer,
            },
          },
          {
            headers: {
              "Accept-Language": this.lang,
              Authorization: "Bearer " + this.accessToken,
            },
          }
        )
        .then((res) => {
          console.log(res.data);
        })
        .catch((error) => {
          console.log(error);
          this.loadingStatus = false;
          if (error.response.status == 403) {
            this.getNewToken();
            console.log("getNewToken");
          } else {
            this.error = error;
            console.log(error);
          }
        });
    },
    updateCustomer() {
      let data = {
        gender: this.form.sex,
      };
      if (!this.form.ssid || this.form.ssid == "xx") {
        data["birthDate"] = this.form.birthDate;
      }
      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/customer/update",
          {
            updateCustomerReqBean: data,
          },
          {
            headers: {
              "Accept-Language": this.lang,
              Authorization: "Bearer " + this.accessToken,
            },
          }
        )
        .then((res) => {
          console.log(res.data);
        })
        .catch((error) => {
          console.log(error);
          this.loadingStatus = false;
          if (error.response.status == 403) {
            this.getNewToken();
            console.log("getNewToken");
          } else {
            this.error = error;
            console.log(error);
          }
        });
    },
    getNewToken() {
      // 1. Generate a CognitoUser object
      this.$store.state.userPool = new AmazonCognitoIdentity.CognitoUserPool(
        config.poolData
      );

      const userData = {
        Username: this.$cookies.get("username"),
        Pool: this.$store.state.userPool,
      };

      const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
      // 2. Generate a RefreshToken object
      var refresh_token = this.$cookies.get("refresh_token");
      const refreshToken = new AmazonCognitoIdentity.CognitoRefreshToken({
        RefreshToken: refresh_token,
      });

      cognitoUser.refreshSession(refreshToken, (err, session) => {
        if (err) {
          console.log(err);
        } else {
          this.accessToken = session.getIdToken().getJwtToken();
          this.$cookies.set("access_token", this.accessToken);
          this.$cookies.set(
            "refresh_token",
            session.getRefreshToken().getToken()
          );
          this.getData();
          this.getOldData();
        }
      });
    },
  },
});
</script>

<style lang="scss" scoped>
.check-icon {
  border-radius: 4.3rem;
  background-color: #6db557;
  cursor: pointer;
  transition: 0.3s;
}

.form-container {
  padding-top: 4rem;
  // padding-bottom: 10rem;
  min-height: 100vh;

  img {
    width: 100%;
  }

  .question-title {
    font-size: 1.8rem;
    font-weight: 400;
    color: #000;
    user-select: none;
    word-break: break-word;
    // font-family: "Libre Caslon Text", serif;
  }

  @media only screen and (max-width: 514px) {
    min-height: 100vh;
  }
}

.questionatitle {
  width: calc(100% - 3rem);
  font-size: 1.5rem;
  margin: auto;
  margin-top: 10px;
}

.footer-nav {
  background: #ffffff;
  width: 100%;
  height: 8rem;
  margin-top: 4rem;
  position: fixed;
  z-index: 99;
  bottom: 0;
  box-shadow: 0px 0px 13px 0px #c7c7c740;
  display: flex;
  align-items: center;
  justify-content: center;

  .footer-btn-next {
    width: calc(100% - 3.6rem);
    max-width: 50rem;
    margin: auto;
    // margin: 2rem auto;
    padding: 0 1.8rem;
  }
}

.image-middle {
  height: 30rem;
  width: 30rem;
  max-height: 400px;
  max-width: 100vw;
}

.head-link-container {
  padding: 2rem 1.6rem 0;

  @media only screen and (max-width: 514px) {
    padding: 1.6rem;
  }

  .bt-back {
    width: 3.5rem;
    height: 3.5rem;
    border-radius: 3.5rem;
    background: #ffffff;
    transition: 0.3s;
    cursor: pointer;
    filter: drop-shadow(3px 4px 7px rgba(165, 165, 165, 0.25));

    &:hover {
      background-color: #f3f3f3;
      filter: drop-shadow(1px 1px 3px rgba(165, 165, 165, 0.45));
    }
  }

  .link {
    color: #000;
    font-size: 1.6rem;
    text-decoration-line: underline;
    cursor: pointer;
  }
}

.footer {
  width: 100%;
  height: 0.1rem;
}

.bottom-screen {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 1;

  .footer-modal {
    margin: auto;
    max-width: 48rem;
    padding: 2.4rem;
    height: 18rem;
    background-color: #fff;
    border-radius: 3rem 3rem 0 0;
    text-align: center;
  }
}

.question-title {
  font-size: 1.8rem;
  font-weight: 400;
  color: #000;
  user-select: none;
  // font-family: "Libre Caslon Text", serif;
}

.sex-container {
  .select-box {
    position: relative;
    width: 28rem;
    height: 13.2rem;
    border-radius: 15.2rem;
    background-color: #f3f3e7;
    cursor: pointer;

    .button {
      width: 11rem;
      height: 11rem;
      border-radius: 11rem;
      z-index: 1;
      user-select: none;
      transition: 0.3s;
      color: #525252;
      font-weight: 500;
      font-size: 1.6rem;
    }

    .button.focus {
      color: #206b5e;
    }

    .white-cyecle {
      background-color: white;
      position: absolute;
      box-shadow: 0.2rem 0.4rem 0.9rem rgba(141, 154, 132, 0.25);
    }

    .white-cyecle.M {
      left: 1rem;
    }

    .white-cyecle.F {
      left: calc(100% - (1rem + 11rem));
    }
  }
}

.career-container {
  .image-middle {
    height: 36rem;
    width: 36rem;
    max-height: 300px;
    max-width: 100vw;
  }
}

.health-details-container,
.activity-container,
.sports-container {
  .image-middle {
    height: 36rem;
    width: 36rem;
    max-height: 300px;
    max-width: 100vw;
  }

  .body {
    width: 100%;
    max-width: 300px;
    padding: 0px 10px;
    margin: auto;
    padding-bottom: 10rem;
  }
}

.body-details-container {
  .image-middle {
    height: 36rem;
    width: 36rem;
    max-height: 300px;
    max-width: 100vw;
  }

  .body {
    width: 100%;
    max-width: 300px;
    padding: 0px 10px;
    margin: auto;

    .body-details-box {
      position: relative;
      // display: flex;
      display: block;
      align-items: center;

      .title {
        margin-top: 2rem;
        margin-bottom: 1rem;
        align-items: left;
        color: #545454;
        font-size: 1.6rem;
        font-weight: 400;
      }

      .absolute-text {
        margin-top: -3rem;
        position: absolute;
        // // top: 50%;
        // right: 1rem;
        // transform: translate(-50%, -50%);
        line-height: 5rem;
        // font-size: 1.2rem;
        font-size: 1.6rem;
        font-weight: 400;
        color: #000000;
        pointer-events: none;
      }
    }
  }
}

.health-details-container {
  .body {
    width: 100%;
    // max-width: 300px;
    // padding: 0px 10px;
    margin: auto;

    .health-details-box {
      font-size: 1.6rem;
      font-weight: 400;
      color: #545454;
      margin-top: 3.6rem;

      .pressure-box {
        width: 100%;
        background: #f3f3e7;
        align-items: center;
        position: relative;
        margin-top: 1rem;
        border-radius: 2rem;
        display: block;

        .input-box {
          padding: 1.5rem;
          display: grid;
          grid-template-columns: calc(40% - 0.8rem) calc(60% - 0.8rem);
          gap: 1rem;
          color: #545454;
          font-size: 1.4rem;
          font-weight: 400;

          .label {
            font-size: 1.4rem;
            font-weight: 400;
            line-height: 5rem;
          }

          .absolute-text {
            margin-top: 3rem;
            // position: absolute;
            display: flex;
            line-height: 5rem;
            align-items: center;

            font-size: 1.4rem;
            font-weight: 400;
            color: #000000;
            pointer-events: none;
          }

          // .box{}
        }
      }

      .cholesterol-box {
        width: 100%;
        align-items: center;
        position: relative;
        margin-top: 1rem;
        display: block;

        .absolute-text {
          margin-top: -2rem;
          // position: absolute;
          display: flex;
          line-height: 5rem;
          align-items: center;

          font-size: 1.4rem;
          font-weight: 400;
          color: #000000;
          pointer-events: none;
        }
      }

      .bloodsugar-box {
        width: 100%;
        align-items: center;
        position: relative;
        margin-top: 1rem;
        display: block;

        .absolute-text {
          margin-top: -3rem;
          // position: absolute;
          display: flex;
          line-height: 5rem;
          align-items: center;

          font-size: 1.4rem;
          font-weight: 400;
          color: #000000;
          pointer-events: none;
        }
      }
    }
  }
}

.exercise-week-container {
  .body {
    width: 100%;
    max-width: 400px;
    margin: auto;

    .select-container {
      // width: 36rem;
      // height: 36rem;
      // position: relative;
      display: block;
      // margin-bottom: 10px;

      .select-box {
        display: flex;

        .option-box {
          width: 80%;
          height: 5rem;
          border-radius: 2rem;
          margin: 1rem 4rem;
          background: #f3f3e7;
          display: flex;
          // box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
          //   5px 5px 10px rgba(163, 162, 162, 0.25);
          // position: absolute;
          font-weight: 500;
          color: #000;
          font-size: 1.6rem;
          cursor: pointer;
          user-select: none;
          transition: 0.3s;

          .text {
            margin: auto;
          }
        }

        .option-box.selected {
          background: #ecf5ca;

          // &:hover {
          //   background: #f7f7f7;
          // }
        }

        .check-icon {
          display: flex;
          // position: absolute;
          z-index: 999;
          top: -11;
          right: 10;
          left: calc((100% + 3rem) / 2);
          width: 4.3rem;
          height: 4.3rem;
          cursor: pointer;
          background: #43b422;
          margin: 0 0 0 -7rem;
          opacity: 0;
        }

        .check-icon.select {
          opacity: 1;
        }
      }

      .top {
        top: 0;
      }

      .bottom {
        top: calc(36rem - 12.7rem);
      }

      .left {
        left: 1rem;
      }

      .right {
        left: calc(100% - 13rem);
      }

      .mid {
        top: calc((36rem - 11rem) / 2);
        left: calc((100% - 11rem) / 2);
      }

      .option-box-mid {
        width: 14rem;
        height: 14rem;
        border-radius: 14rem;
        background-color: rgba($color: #ecf5ca, $alpha: 0.7);
        color: #7b7b7b;
        font-size: 1.8rem;
        z-index: -2;
        transition: 0.3s;
      }

      .option-box-mid.select {
        background-color: #e2f2b9;
      }

      .check-icon {
        display: flex;
        // position: absolute;
        z-index: 999;
        top: 11rem;
        left: calc((100% + 3rem) / 2);
        width: 4.3rem;
        height: 4.3rem;
        cursor: pointer;
        opacity: 0;
        background: #43b422;
      }

      .check-icon.select {
        opacity: 1;
      }
    }
  }
}

.behavior-container {
  .body {
    width: 100%;
    // max-width: 350px;
    margin: 1rem;
    // display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 5.2rem;
    display: grid;
    grid-template-columns: auto auto;
    gap: 1rem;
    padding-bottom: 8rem;

    @media only screen and (max-width: 514px) {
      width: calc(100% - 1rem);
      // padding: 0 3rem;
    }

    .disease-long-card {
      background: #f3f3e7;
      width: 14rem;
      height: 14rem;
      margin: 0.5rem;
      text-align: left;
      display: inline;
      border-radius: 20px;
      // display: flex;
      align-items: center;
      position: relative;
      word-break: break-word;

      // &:hover {
      //   background: #EFF8E9;
      // }
      // background-color: green;
      .icon {
        width: auto;
        height: 5rem;
        // background-color: salmon;
        // margin: 8px 0px 8px 15px;
        // padding: 8px 0px 8px 15px;
        // margin: 2rem;
        display: flex;
        margin-top: 2rem;
        margin-left: auto;
        margin-right: auto;
        justify-content: center;
        // background-color:red ;
      }

      .label {
        display: block;
        // margin-top: 2rem;
        margin-left: auto;
        margin-right: auto;
        // padding: 0px 20px 0px 20px;
        width: 80%;
        height: 8rem;
        text-align: center;
        //       display: flex;
        justify-content: center;
        line-height: 2rem;
        // background-color: red;
      }

      .check-icon {
        display: none;
      }
    }

    .disease-long-card.error {
      border: 1px solid red;
      outline: 1px solid red;
    }

    .disease-long-card.select {
      background-color: #ecf5ca;
      position: relative;

      .check-icon {
        display: flex;
        position: absolute;
        margin: -10px -10px 0px 0px;
        top: 0;
        right: 0;
        width: 3rem;
        height: 3rem;

        border-radius: 1.8rem;
        background-color: #43b422;
      }
    }
  }
}

.disease-container {
  .body {
    width: 80%;
    // max-width: 300px;
    margin: auto;
    // display: flex;
    display: grid;
    grid-template-columns: auto auto;
    gap: 1rem;

    justify-content: center;
    flex-wrap: wrap;
    margin-top: 3rem;

    // @media only screen and (max-width: 514px) {
    //   width: 80%;
    //   // padding: 0 3rem;
    // }

    .disease-long-card {
      background: #f3f3e7;
      width: 100%;
      // height: 5rem;
      // margin: 0rem 3rem 1.5rem;
      font-size: 1.4rem;
      text-align: left;
      display: inline;
      border-radius: 20px;
      display: grid;
      grid-template-columns: 4rem auto;
      gap: 0rem;
      align-items: center;
      position: relative;

      // &:hover {
      //   background: #EFF8E9;
      // }
      .icon {
        width: 4rem;
        margin: 0px 0px 8px 8px;
      }

      .label {
        font-weight: 500;
        font-size: 1.4rem;
        padding: 0.5rem;
      }
    }

    .disease-long-card.error {
      border: 1px solid red;
      outline: 1px solid red;
    }

    .disease-long-card.select {
      background-color: #ecf5ca;
      position: relative;

      .check-icon {
        display: flex;
        position: absolute;
        margin: -10px -10px 0px 0px;
        top: 0;
        right: 0;
        width: 3rem;
        height: 3rem;
        background-color: #43b422;
      }
    }

    .disease-card {
      position: relative;
      width: 45%;
      padding-top: 45%;
      height: 13rem;
      border-radius: 14rem;
      background: #fff;
      transition: 0.3s;
      cursor: pointer;
      user-select: none;
      margin-bottom: 3.6rem;
      box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
        5px 5px 10px rgba(163, 162, 162, 0.25);

      &:hover {
        background: #f6fbfc;
      }

      .icon {
        width: 5rem;
        height: 5rem;
        border-radius: 5rem;
        background: #fff;
        margin: auto;
      }

      .content {
        position: absolute;
        top: 0;

        // height: 10rem;
        padding-top: 2rem;
        // display: flex;
        // flex-direction: column;
        // justify-content: space-between;
      }

      .label {
        width: 8rem;
        margin: 0 auto;
        font-size: 1.2rem;
        text-align: center;
        height: 4.8rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .check-icon {
      display: none;
    }

    .disease-card.select {
      background-color: #f0f9fb;
      box-shadow: -5px -5px 3px rgba(232, 232, 232, 0.25),
        5px 5px 6px rgba(163, 162, 162, 0.25);

      .check-icon {
        display: flex;
        position: absolute;
        top: 0;
        right: 0;
        width: 4.3rem;
        height: 4.3rem;
      }
    }
  }
}
.disease-container.family {
  padding-bottom: 10rem;
}

.disease-family-container {
  .slide-body {
    // width: calc(19.4rem * 3);
    max-width: 100%;
    // max-width: 600px;
    // margin: auto;
    margin: 5.2rem auto 0;

    // display: flex;
    // flex-wrap: nowrap;
    // overflow: auto;
    // @media only screen and (max-width: 514px) {
    //   width: calc(100% - 6rem);
    //   padding: 0 3rem;
    // }
    .slide-container {
      width: calc(14.3rem * 4);
      display: flex;
      flex-wrap: nowrap;
      overflow: auto;
      margin: auto;
      padding: 1rem 0;
    }

    // .mock-time-card {
    //   width: 100%;
    //   height: 20rem;
    //   width: 20rem;
    //   border-radius: 20rem;
    //   margin: auto;
    // }
    .mock-time-card {
      height: 29rem;
      margin: auto;
    }

    .time-card {
      position: relative;
      // width: 100%;
      height: 24.6rem;
      width: 14.3rem;
      border-radius: 14.3rem;
      background: #fff;
      transition: 0.3s;
      cursor: pointer;
      user-select: none;
      margin: 0 auto 1.2rem;
      box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
        5px 5px 10px rgba(163, 162, 162, 0.25);

      &:hover {
        background: #f6fbfc;
      }

      .check-icon {
        display: none;
      }

      .icon {
        width: 5rem;
        height: 5rem;
        border-radius: 5rem;
        background: #fff;
        margin: auto;
      }

      .content {
        height: 10rem;
        padding-top: 1rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }

      .label {
        width: 8rem;
        margin: 0 auto;
        font-size: 1.4rem;
        text-align: center;
        height: 4.8rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .time-card.select {
      background-color: #eff8e9;
      height: 29rem;
      box-shadow: -5px -5px 3px rgba(232, 232, 232, 0.25),
        5px 5px 6px rgba(163, 162, 162, 0.25);

      .check-icon {
        display: flex;
        position: absolute;
        top: 0;
        right: 0;
        width: 4.3rem;
        height: 4.3rem;
      }
    }
  }
}

.activity-container {
  .body {
    width: 100%;
    max-width: 350px;
    margin: auto;
    margin-top: 5.2rem;

    @media only screen and (max-width: 514px) {
      width: calc(100% - 1rem);
    }

    .btn-select {
      position: relative;
      width: 100%;
      height: 6rem;
      padding: 0 4rem;
      border-radius: 2rem;
      background: #f3f3e7;
      transition: 0.3s;
      cursor: pointer;
      user-select: none;
      margin-bottom: 1.4rem;
      font-size: 1.3rem;
      font-weight: 500;

      .check-icon {
        display: none;
      }

      // &:hover {
      //   background: #EFF8E9;
      // }
    }

    .btn-select.select {
      background-color: #ecf5ca;

      .check-icon {
        margin: -10px -10px 0px 0px;
        display: flex;
        position: absolute;
        top: 0;
        right: 0;
        width: 2.8rem;
        height: 2.8rem;
      }
    }
  }
}

.exercise-time-container {
  .slide-body {
    // width: calc(19.4rem * 3);
    max-width: 100%;
    // max-width: 600px;
    // margin: auto;
    margin: 5.2rem auto 0;

    // display: flex;
    // flex-wrap: nowrap;
    // overflow: auto;
    // @media only screen and (max-width: 514px) {
    //   width: calc(100% - 6rem);
    //   padding: 0 3rem;
    // }
    .slide-container {
      width: calc(19.4rem * 4);
      display: flex;
      flex-wrap: nowrap;
      overflow: auto;
      margin: auto;
      padding: 1rem 0;
    }

    .mock-time-card {
      width: 100%;
      height: 20rem;
      width: 20rem;
      border-radius: 20rem;
      margin: auto;
    }

    .time-card {
      position: relative;
      width: 100%;
      height: 15.4rem;
      width: 15.4rem;
      border-radius: 15.4rem;
      background: #f3f3e7;
      transition: 0.3s;
      cursor: pointer;
      user-select: none;
      margin: 0 auto 1.2rem;

      // box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
      //   5px 5px 10px rgba(163, 162, 162, 0.25);
      // &:hover {
      //   background: #f6fbfc;
      // }
      .label {
        font-size: 1.6rem;
        font-weight: 500;
        width: 12rem;
        text-align: center;
      }

      .check-icon {
        display: none;
      }
    }

    .time-card.select {
      background-color: #eff8e9;
      height: 20rem;
      width: 20rem;
      border-radius: 20rem;
      // box-shadow: -5px -5px 3px rgba(232, 232, 232, 0.25),
      //   5px 5px 6px rgba(163, 162, 162, 0.25);

      .check-icon {
        display: flex;
        position: absolute;
        top: 0;
        right: 0;
        width: 4.3rem;
        height: 4.3rem;
      }
    }
  }
}

.sports-container {
  .body {
    width: 100%;
    max-width: 350px;
    margin: auto;

    @media only screen and (max-width: 514px) {
      width: calc(100% - 1rem);
      padding: 0 3rem;
    }

    .sports-btn {
      position: relative;
      width: 100%;
      max-width: 10rem;
      height: 10rem;
      border-radius: 10rem;
      background: #f3f3e7;
      transition: 0.3s;
      cursor: pointer;
      user-select: none;
      margin-bottom: 3.6rem;

      // box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
      //   5px 5px 10px rgba(163, 162, 162, 0.25);
      // &:hover {
      //   background: #eff8e970;
      // }
      .label {
        transition: 0.3s;
        font-size: 1.8rem;
        font-weight: 500;
        opacity: 0.7;
        color: #000;
      }
    }

    .sports-btn.select {
      background-color: #ecf5ca;

      // box-shadow: -5px -5px 3px rgba(232, 232, 232, 0.25),
      //   5px 5px 6px rgba(163, 162, 162, 0.25);
      .label {
        opacity: 1;
      }
    }
  }
}

.finish-container {
  .body {
    width: 100%;
    max-width: 350px;
    margin: auto;
    height: 40vh;

    @media only screen and (max-width: 514px) {
      width: calc(100% - 6rem);
      padding: 0 3rem;
    }
  }
}

.absolute-text {
  position: absolute;
  // top: 50%;
  right: 1rem;
  transform: translate(-50%, -50%);
  font-size: 1.2rem;
  font-weight: 500;
  color: #000000;
  pointer-events: none;
}

.date-selected {
  height: calc(3.6rem * 3);
  width: 10rem;
}

.date-selected-date {
  height: calc(3.6rem * 3);
  width: 8rem;
}

.date-selected-month {
  height: calc(3.6rem * 3);
  width: 12rem;
}

.date-selected-year {
  height: calc(3.6rem * 3);
  width: 8rem;
}

.focus-bg-date {
  width: 6rem;
  height: 3.6rem;
  background: #f3f3e7;
  border-radius: 1.5rem;
}

.focus-bg-month {
  width: 12rem;
  height: 3.6rem;
  background: #f3f3e7;
  border-radius: 1.5rem;
}

.focus-bg-year {
  width: 7rem;
  height: 3.6rem;
  background: #f3f3e7;
  border-radius: 1.5rem;
}

.top-bottom-bg-date {
  width: 6rem;
  height: calc(3.6rem * 3);
  z-index: 3;
  pointer-events: none;
  background-image: linear-gradient(#fff, transparent, #fff);
}

.top-bottom-bg-month {
  width: 12rem;
  height: calc(3.6rem * 3);
  z-index: 3;
  pointer-events: none;
  background-image: linear-gradient(#fff, transparent, #fff);
}

.top-bottom-bg-year {
  width: 7rem;
  height: calc(3.6rem * 3);
  z-index: 3;
  pointer-events: none;
  background-image: linear-gradient(#fff, transparent, #fff);
}

.step-progress {
  height: 0.3rem;
  margin-top: 1.4rem;
  display: grid;
  grid-template-columns: repeat(7, calc(14% - (0.4rem / 7)));
  gap: 0.2rem;
  width: 100%;
  background-color: #f3f3e7;

  .step-bar {
    height: 0.3rem;
    width: 100%;
    background: #6db557;
  }
}

.el-select-dropdown__item.selected {
  color: #000;
}
</style>

<style lang="scss">
.focus-bg-exercise {
  width: 30rem;
  height: 4.8rem;
  background: #ecf5ca;
  border-radius: 1.8rem;
}

.top-bottom-bg-exercise {
  width: 30rem;
  height: calc(4.8rem * 3);
  z-index: 3;
  pointer-events: none;
  background-image: linear-gradient(#fff 0%, transparent 50%, #fff 100%);
}

.exercise-selected-exercise {
  height: calc(4.8rem * 3);
  width: 26rem;
}

#question_page {
  .date-input {
    width: 100%;
    max-width: 11.8rem;
    height: 3.6rem;
    border-radius: 3.6rem;

    .el-input__inner {
      font-size: 1.8rem;
      height: 3.6rem;
      border-radius: 3.6rem;
      border: 0;
      outline: 0;
      box-shadow: none;
      border: 1px solid #eff8e9;
      background-color: #eff8e9;
      text-align: center;

      &:focus {
        box-shadow: 0 0 0 1px #206b5e inset !important;
        border: 1px solid #206b5e;
      }
    }
  }

  .date-input.validate {
    .el-input__inner {
      outline: 1px solid red;
    }
  }

  .width-250 {
    max-width: 25rem;
  }

  .width-160 {
    max-width: 16rem;
  }

  .width-150 {
    max-width: 15rem;
  }
}

.yes-no-btn {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 1.25rem;
  background-color: #f3f3e7;
  font-size: 1.8rem;
  font-weight: 500;
}

.yes-no-btn.select {
  background: #ecf5ca;
}
</style>
